/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {DocRole, EDITOR_MODE, EnumShareInviteType, ENVIRONMENT_LEVEL, PageScope} from '@/Constant';
import {IDocType} from '@/constants/document/doc';
import {isHi} from '@/utils/browserUtils';
import {DocumentUpdateOperation} from '@/interface';
import {isInKuShare} from '@/utils/urlUtils';
import kuPiper from '@/middleware/core';
import * as store from '@/store';
import {create, createContentWrap, createHistory, createReportBody, Logger} from '@baidu/infoflow-fe-logger';
import {getIsSdkPage} from '@/kuSdk/view/DocViewAll/utils/isSdkPage';

/* eslint-disable complexity */
/* eslint-disable camelcase */
export interface BaseId {
    pageId?: string;
    repoId?: string;
    groupId?: string;
}

export interface BaseIdParams {
    page_id?: string;
    kb_id?: string;
    kb_org_id?: string;
}

interface searchDetailParams extends BaseIdParams {
    type?: string | number;
    title?: string;
    owner?: string;
    last_update_time?: string | number;
    floor_id?: number;
    authority_type?: string;
}
interface SearchResSingleViewParams extends BaseIdParams {
    type?: string | number;
    title?: string;
    name?: string;
    pos_absolute?: number | string;
    is_click_emptyRef?: string;
}
interface SearchInfoParams {
    operate_name?: string;
    show_tag_num?: string;
    page_count?: string;
    area_type?: string;
    history_query?: string;
    name?: string;
    query_id?: string;
    single_view?: SearchResSingleViewParams;
    query?: string;
    opt_type?: string;
    opt_value?: any;
    detail?: searchDetailParams[];
    size?: string;
    timestamp_fe_request?: string;
    timestamp_fe_response?: string;
    status_code?: number | string;
    error_msg?: string;
}
interface IPageInfoParams extends BaseIdParams, SearchInfoParams, SearchResSingleViewParams {
    [name: string]: string | string[] | number | BaseIdParams | undefined | null | BaseId
                | SearchResSingleViewParams | searchDetailParams[] ;
    type?: string | number;
    source?: string;
    tag_content?: string;
    s_number?: string;
    s_number_show?: string;
    tag_cont?: string;
}

interface loggerInterface{
    rep_id: string;
    rep_params?: IPageInfoParams;
    rep_type?: string;
    rep_timestamp?: number | null;
}


export enum RoleLoggerType {
    Repository = 1,
    Page = 2,
    personalHome = 3,
}

export enum TagType {
    recommend = '1',
    selfSelect = '0',
}

export enum SourceType {
    url = '0',
    kuShare = 'meetingshare',
}

export enum PageType {
    repository = '0',
    page = '1',
    department = '2',
}

export enum AreaType {
    recentBrowse = '1',
    historyWord = '2',
}

export enum SearchFilterType {
    type = '1',
    editor = '2',
    range = '3',
    editTime = '4',
}

export enum SearchFilterTypeRange {
    all = '1',
    page = '2',
    repository = '3',
}

export enum SearchFilterTimeRange {
    all = '1',
    recentOneDay = '2',
    recentOneWeek = '3',
    recentMonth = '4',
    recentThreeMonths = '5',
}

export enum SearchFilterRange {
    all = '1',
    curRepository = '2',
}

export enum MentionSource {
    content = '1',
    underLineComment = '2',
}

export const DocType: {[index: string]: number | string} = {
    doc: 1,
    directory: 2,
    // 数据表夹
    sheet: 3,
    ppt: 4,
    // 单个数据表
    datasheet: 5,
};

export const curPageType = {
    doc: 'doc',
    repository: 'repository',
    department: 'department',
    directory: 'directory',
    recent: 'recent',
    sheet: 'sheet',
    ppt: 'ppt',
};

export const ShareSource: {[index: string]: number | string} = {
    doc: 1,
    repository: 2,
    department: 3,
    directory: 4,
    recent: 5,
    sheet: 6,
    ppt: 7,
};

export const modeType = {
    [`${EDITOR_MODE.preview}`]: 1,
    [`${EDITOR_MODE.edit}`]: 2,
    [`${EDITOR_MODE.meeting}`]: 3,
};

export function retDocumentMode(documentMode: EDITOR_MODE | undefined) {
    if (documentMode === EDITOR_MODE.preview) {
        return '阅读模式';
    } else if (documentMode === EDITOR_MODE.edit) {
        return '编辑模式';
    } else if (documentMode === EDITOR_MODE.meeting) {
        return '协作模式';
    } else {
        return '';
    }
}

export const DocPublicType = {
    [`${DocumentUpdateOperation.Add}`]: 1,
    [`${DocumentUpdateOperation.Delete}`]: 2,
};

export const DocPublicEmpowermentType = {
    [`${PageScope.PagePublic}`]: 1,
    [`${PageScope.PagePublicEdit}`]: 2,
};

export const MemberPermission = {
    [`${DocRole.DocAdmin}`]: 2,
    [`${DocRole.Member}`]: 1,
    [`${DocRole.Reader}`]: 0,
    remove: 3,
};

export const FilterType = {
    authority: 'authority',
    type: 'type',
    date: 'date',
    match: 'match',
};

export const FilterTypeVal = {
    [`${FilterType.authority}`]: 1,
    [`${FilterType.type}`]: 2,
    [`${FilterType.date}`]: 3,
    [`${FilterType.match}`]: 4,
};

export const Authority = {
    noChecked: 0,
    checked: 1,
};

export const SearchResType: {[index: string]: number} = {
    all: 1,
    ku: 2,
    doc: 3,
    sheet: 4,
    book: 5,
    ppt: 6,
};

export const UpdateTime: {[index: string]: number} = {
    all: 1,
    day: 2,
    week: 3,
    month: 4,
    months: 5,
};

export const Match: {[index: string]: number} = {
    all: 1,
    content: 2,
    title: 3,
};

export const UserInfoCardOperate = {
    hoverCard: 1,
    clickPersonalHomePage: 2,
    clickRuLiuChat: 3,
    clickEmail: 4,
    clickHoverTarget: 5,
};

export const SEARCH_SOURCE = {
    searchHistory: 1,
    relatedSearch: 2,
};

// 设置-智能推荐、其他
export enum ClickSettingType {
    // 智能标签用户设置
    tagReading='80001.1.22',
    // 知识星链用户设置
    linking = '80001.1.23',
    // 文档相关推荐用户设置
    recommendReading = '80001.1.24',
    // 文档引用用户设置
    citeReading = '80001.1.25',
    // 自动关注自己创建的文档
    autoSubscribe = '80001.1.126',
    // 图片智能分析
    openOCR = '80001.1.212'
}


const shareRepId = '80001.1.1';
const deleteRepId = '80001.1.2';
const demonstrationRepId = '80001.1.3';
// const restoreHistoryRepId = '80001.1.4';
// const pluginRepId = '80001.1.5';
const shredRepId = '80001.1.6';
const removeMemberRepId = '80001.1.9';
const mentionId = '80001.1.12';
const editRepId = '80001.2.1';
const publishRepId = '80001.2.2';
const openPageRepId = '80001.2.3';
const openHomeRepId = '80001.3.1';
const openRepositoryRepId = '80001.4.1';
const openHomeInTreeRepId = '80001.4.2';
// const openPageInTreeRepId = '80001.4.3';
const openSettingRepId = '80001.4.4';
const openRecycleBinRepId = '80001.4.5';
const editDocumentId = '80001.1.10';
const clickHomeIconId = '80001.3.2';
const clickMyDepartmentId = '80001.3.3';
const clickMyKuId = '80001.3.4';
const clickMeFollowKuId = '80001.3.5';
const clickMeFollowPageId = '80001.3.6';
const clickRecentBrowsingKuId = '80001.3.7';
const clickRecentBrowsingPageId = '80001.3.8';
const searchRecommendTagId = '80001.2.4';
const addTagTypeId = '80001.2.5';
const newBuildPageId = '80001.2.6';
const opepnContribute = '80001.2.89';

// 标签聚合
const deleteTagRepId = '80001.2.8';
const entryTagRepId = '80001.2.12';
const catalogueTagRepId = '80001.2.13';
const togetherTagRepId = '80001.2.14';
const tagClickRepId = '80001.2.16';
const openPageTagRepId = '80001.2.34';
const moreTagClickRepId = '80001.2.41';

// 百科分类
const baikeTagClickRepId = '80001.2.77';
const baikeTagNewClickRepId = '80001.2.116';
const openBaikeTagRepId = '80001.2.117';
const turnPagesBaikeTagRepId = '80001.2.118';
const baikeEntryClickRepId = '80001.2.119';

const quickAuthorizePopperId = '80001.9.5';
const quickAuthorizeBtnId = '80001.9.7';
const clickICafeCardId = '80001.1.17';
const relatedICafeCardId = '80001.1.16';
const cancelIApiId = '80001.3.27';
const robotStarlinkRepId = '80001.2.370';
const hoverRobotStarlinkRepId = '80001.2.371';
// 点击会议
const clickMeetingsId = '80001.2.350';
// hover会议
const hoverMeetingsId = '80001.2.349';
// 会议模式相关
const startMeetingBtnId = '80001.9.1';
const stopMeetingBtnId = '80001.9.2';
const sendNotifyToMentionsId = '80001.9.4';
// // 部门知识库相关
const enterDepartmentId = '80001.5.1';
const openDepartmentTabId = '80001.5.2';
const followDepartmentId = '80001.5.3';
const cancelFollowDepartmentId = '80001.5.4';
const shareDepartmentId = '80001.5.5';
const departmentDeleteTagId = '80001.5.6';
const departmentCreateTagId = '80001.5.7';
const departmentHomeEditintroductionId = '80001.5.8';
const departmentViewDetailId = '80001.5.9';
const departmentEditNoticeId = '80001.5.10';
const departmentHotKuId = '80001.5.11';
const departmentMessageBoardReleaseId = '80001.5.12';
const departmentMessageBoardReplyId = '80001.5.13';
const departmentMessageBoardDeleteId = '80001.5.14';
const departmentOutKuRecommendAddId = '80001.5.15';
const departmentOutKuRecommendDeleteId = '80001.5.16';
const departmentHotKuOpenKuId = '80001.5.17';
const departmentOutKuOpenKuId = '80001.5.18';
const departmentkuListOpenKuId = '80001.5.19';
const departmentHomeNoticeViewAllId = '80001.5.20';
const clickSearchId = '80001.6.1';
const searchClickPageId = '80001.6.2';
const searchClickKuId = '80001.6.3';
const documentLikeClick = '80001.8.32';
const documentCommentClick = '80001.8.33';
const documentCommentSdkClick = '80001.20.9';
const documentCooperationClick = '80001.8.34';
const shareCopeLinkId = '80001.5.21';
const shareBtnId = '80001.5.22';
const outOrDepartmentKBConfirmId = '80001.5.23';
const removeOutOrDepartmentId = '80001.5.24';
const enterDepartmentRepositoryId = '80001.5.25';
const enterDepartmentMembersId = '80001.5.26';
const enterDepartmentSettingId = '80001.5.27';
const enterDepartmentRecycleId = '80001.5.28';
const enterDepartmentIntroductionId = '80001.5.29';
const enterDepartmentMessageId = '80001.5.30';
// 部门知识库添加推荐按钮
const clickRecommendRepoAddBtn = '80001.5.61';
// 点击部门首页推荐知识库的置顶按钮
const clickRecommendRepoTopBtn = '80001.5.63';
// 点击部门首页推荐知识库的移除按钮
const clickRecommendRepoDelBtn = '80001.5.64';
// 点击部门首页数据概览的全部按钮
const clickDataOverviewAllBtn = '80001.5.62';
// 部门知识库首页的曝光
const showDepartmentIndexId = '80001.5.31';
// 部门知识库统计Tab
const showStatistics = '80001.5.32';
// 知识库搜索
const clickRecentAreaId = '80001.11.1';
// 点击移动到按钮
const moveToBtnId = '80001.1.66';
// 点击复制到按钮
const copyToBtnId = '80001.1.65';
const inputSearchId = '80001.11.2';
const searchResultOperateId = '80001.11.3';
const searchResultShowId = '80001.11.4';
const clickSearchListItemId = '80001.11.5';
const searchFilterId = '80001.11.6';
const pulldownLoadMoreId = '80001.11.7';
const activeSearchId = '80001.11.9';
const searchAPIErrorId = '80001.11.8';

const searchSceneId = '80001.1.30';
const searchClickSceneId = '80001.2.46';
const clickMentionGroupId = '80001.8.200';
// 打开百科文档页
const openBaikePageReportId = '80001.2.100';

// 文档域 文章页面
const expandReferenceId = '80001.2.18';
const clickDocReferenceId = '80001.2.19';
const openDocShowReferenceId = '80001.2.17';
const openShowRecommendReadingId = '80001.2.35';
const clickRecommendReadingId = '80001.2.36';
const turnPagesRecommendReadingId = '80001.2.37';
const closeRecommendReadingId = '80001.2.38';
const clickAvatarSyncViewId = '80001.2.43';
const clickHistoryVersionId = '80001.2.51';
const openRLDialogId = '80001.2.317';

const editorTemplateReadingId = '80001.2.45';
// 文档浏览超过10s上报埋点
const longBrowsingTimeId = '80001.2.199';
// hover展现创建者卡片
const showCreatorId = '80001.2.200';
// 在创建者卡片点击头像进入个人主页
const clickCreatorId = '80001.2.201';

// 知识库最近预览相关埋点
const hoverRecentBrowseRecords = '80001.2.121';
const clickRecentBrowseRecords = '80001.2.122';
const clickRecentBrowseRecordsSwitch = '80001.2.123';


const createBookId = '80001.1.27';
const openBookId = '80001.1.28';
const bookOperateId = '80001.1.29';

// 触发关注动作
const flowDocumentId = '80001.1.21';
// 关注/取消关注文档更新
const flowDocumentUpdateId = '80001.2.265';
// 关注/取消关注文档评论
const flowDocumentCommentId = '80001.2.266';
// 关注/取消关注文档权限变化
const flowDocumentPermissionId = '80001.2.267';

// 复制短链接
const copyShortLinkId = '80001.1.34';
// 分享协作相关
const docPublicId = '80001.2.56';
const docPublicEmpowermentId = '80001.2.57';
const enterAddMemberModalId = '80001.2.58';
const addMemberId = '80001.2.59';
const enterPageMemberListModalId = '80001.2.60';
const pageMemberListUpdatePermissionId = '80001.2.61';
const enterShareToRuLiuPopperId = '80001.2.62';
const shareToRuLiuId = '80001.2.63';
// 数据表权限设置面板展现
const datasheetPermSettingShowId = '80001.2.275';

const editHotKeyId = '80001.1.108';
const publishHotKeyId = '80001.1.109';
const openPublicTimeLiness = '80001.3.14';

// 文档页面 visibilitychange 与 focus
const docPageVisibilityRepId = '80001.2.64';
const docPageFocusRepId = '80001.2.65';

const docKuShareWsErrorId = '80001.2.112';
const docKuShareWsReconnectId = '80001.2.113';
const docKuShareWsDataErrorId = '80001.2.135';
// ku享埋点补充
const openKuShareId = '80001.2.319';
const clickFollowButtonId = '80001.2.320';
const onCancelFollowId = '80001.2.321';
const wsMsgBacklogId = '80001.2.322';
const createWsFailedId = '80001.2.323';
const wsReconnectTooMoreId = '80001.2.324';
const wsHeartbeatFailedId = '80001.2.325';
const wsNotFoundId = '80001.2.326';
const setSnapshotFailedId = '80001.2.327';
const followUrlNotFoundId = '80001.2.328';
const jsSdkMetingErrorId = '80001.2.329';
const bdHiJsDiffTimeId = '80001.2.333';
const kuSharePvId = '80001.2.334';
const bdHiJsTimeoutId = '80001.2.335';

// 导入 Excel 表格
const importExcelFromClientRepId = '80001.2.69'; // 从客户端导入
const importExcelFromWebRepId = '80001.2.70'; // 从 Web 端导入
// 导入 PPT
const importPPTFromWebRepId = '80001.2.90'; // 从 Web 端导入
// 导入 Word
const importWordFromWebRepId = '80001.1.35'; // 从 Web 端导入
// 导入 PDF
const importPDFFromWebRepId = '80001.1.36'; // 从 Web 端导入
// 导入 Excel（数据表）
const importExcelDstFromWebRepId = '80001.2.142'; // 从 Web 端导入

// 导出 PPT
const exportPPTRepId = '80001.2.94';

// 导出 Excel（数据表）
const exportExcelDstRepId = '80001.2.143';

// 播放/退出播放 PPT
const playPPTRepId = '80001.2.93';

// 下载原始文件
const downloadOriginalFileRepId = '80001.1.64';

// 划线评论转发按钮点击
const lineationCommentShareBtnClickRepId = '80001.8.118';
// 划线评论确认分享
const lineationCommentShareRepId = '80001.8.119';
// 点击icon打开划线评论
const openRightCommentRepId = '80001.1.290';

// 知识本继承知识库权限相关
const bookPageInheritId = '80001.2.67';
// 打印/导出PDF
const printExportId = '80001.2.76';
// 打印/导出PDF携带目录
const printPDFCarryDirectoryId = '80001.2.204';
// 打印/导出PDF不携带目录
const printPDFNoCarryDirectoryId = '80001.2.205';

// 文档一键回顶
const returnTopId = '80001.2.264';
// 点击洞听
const dongtingId = '80001.1.297';

// 部门打开新手引导视频
const departmentOpenVideoId = '80001.5.33';
// 部门内播放新手引导视频
const departmentPlayVideoId = '80001.5.34';

// 搜索落地页相关
const clickSearchPageEntryId = '80001.19.1';
const clickListItemFromSearchPageId = '80001.19.4';
const clickHotKnowledgeId = '80001.19.2';
const searchId = '80001.19.3';
const auxiliaryInfoId = '80001.19.5';
const pageTurnId = '80001.19.6';
const showRecommendQueryId = '80001.19.7';
const clickRecommendQueryId = '80001.19.8';
const relatedPersonId = '80001.19.9';
const filterId = '80001.19.10';
// 搜索落地页右侧下拉菜单使用
const clickSearchPageAvatarMenu = '80001.19.11';

// 我管理的部门也没埋点ID
const departmentManageLoadId = '80001.3.12';
const departmentManageListClickId = '80001.5.40';
const departmentManageDocSortId = '80001.5.41';
const departmentManageRepoSortId = '80001.5.42';
const departmentManageMemberSortId = '80001.3.9';
const departmentManageSearchId = '80001.3.10';
const departmentManageDownloadId = '80001.3.11';

// 知识库移入部门
const repoMoveInDepartmentId = '80001.5.50';

// 知识库页面移动（目录树操作及顶部栏移动）
const docMoveId = '80001.5.51';
// 完成移动到功能
const docMoveToRepId = '80001.2.198';

// 关于我的汇总信息相关埋点
const aboutMeTooltipId = '80001.2.340';
const aiIconClickId = '80001.2.341';
const aboutMePageShowId = '80001.2.342';
const aboutMeFilterClickId = '80001.2.343';
const aboutMeListClickId = '80001.2.344';
const aboutMeExpandedId = '80001.2.345';
const aboutMeFewerId = '80001.2.346';

// 机器人读写埋点
const starlinkDeatilClickId = '80001.2.372';

// 完成复制到功能
const docCopyToRepId = '80001.2.197';
// 部门公告相关埋点
const departmentNoticePublishedId = '80001.5.35';
const departmentNoticeDetailId = '80001.5.36';
const departmentNoticeMsgSendId = '80001.5.37';
const departmentNoticeOtherSettingId = '80001.5.38';
// 部门首页 / 全部公告 / 发布公告
const publishDeptBindGroupId = '80001.5.52';
const publishDeptUnbindGroupId = '80001.5.53';

// 部门知识库首页相关埋点
const departmentAllAnnouncementID = '80001.5.54';
const departmentAnnouncementModuleID = '80001.5.55';
const departmentRecommendRepoID = '80001.5.58';
const departmentCollectionModuleID = '80001.5.59';
const departmentAddCollectionID = '80001.5.60';
const departmentWallCoinDocClickID = '80001.1.78';
const departmentWallAvatarClickID = '80001.5.65';

// 底部评论回复内容中 @ 人的数量
const bottomCommentMentionNum = '80001.2.101';
// 站内通知入口点击量
const messageCenterId = '80001.3.13';
const homePageEntryId = '80001.16.19';
// 我关注的相关埋点
const addOrCancelAttentionFromHeadMenuId = '80001.2.124';

// 划选字数统计
const selectionWordCountId = '80001.2.195';

// 权限优化-部门内公开（知识库、知识本、文档）
const permissionsOpenDeptID = '80001.1.37';

// pdf转word 点击转换
const pdf2Word = '80001.2.114';

// 点击下载全部附件按钮
const downloadAnnex = '80001.8.116';

// 下载全部附件- 附件数量&大小
const attachmentNumSize = '80001.8.117';
// 打开团队知识库主页（判断下方列表是使用数据表能力展示 OR 旧的列表形式）
const openTeamRepoHomeRepId = '80001.4.16';

// 知识库页面权限导出(点击知识库成员管理页中的【导出知识库及页面的权限】按钮)
const exportRepositoryAuthorityPagesRepId = '80001.1.82';

// 创建数据表块
const CreateDataSheetBlock = '80001.8.129';

// 知识库首页点击【上级组织】
const HomeClickOrganization = '80001.5.66';
// 展现「D+组织知识库」首页
const ShowGUGroupHome = '80001.5.67';
// 展现D+的「知识库」 tab
const ShowGUGroupRepo = '80001.5.68';
// 展现D+的「成员」 tab
const ShowGUGroupMember = '80001.5.69';
// 展现D+的「统计」 tab
const ShowGUGroupStatistics = '80001.5.70';

// 展示权限申请页
const PermissionPage = '80001.2.186';

// ai模板展示
const showAiTemplatesId = '80001.2.189';
// ai模板使用
const genAiTemplatesId = '80001.2.190';
// ai模板激活
const focusAiTemplatesId = '80001.2.193';
// 添加只能洞察弹窗点击确定
const addQuestionAnswer = '80001.3.15';
// 关闭问答功能
const closeQuestionAnswer = '80001.3.16';
// 点击智能问答menu
const clickQuestionAnswerInHelperId = '80001.3.17';
// 智能问答提问
const sendQuestionAnswerId = '80001.3.18';


// 日志页面匹配：筛选的用户匹配日志
const searchSettingLogByUserBuried = '80001.4.19';

// 卡片视图埋点
const switchViewRepId = '80001.2.207';
const switchDemoModeStateRepId = '80001.2.212';
const recordDocCardViewRepId = '80001.2.226';
const newSceneSwitchViewRepId = '80001.2.231';
const enterDemoModeViewRepId = '80001.2.247';
const createNewDocViewRepId = '80001.2.248';

// 卡片视图 ai 模板
const showAiTemplatesInCardId = '80001.2.252';
const genAiTemplatesInCardId = '80001.2.253';
const focusAiTemplatesInCardId = '80001.2.254';

// 申请权限增加埋点
const pageSendApplyId = '80001.1.137';
const knowledgeSendApplyId = '80001.1.138';
// 权限审批及审批流程数据建设
const permissionApplyId = '80001.1.236';

// 站内通知同意/不同意申请增加埋点
const pageAgreeApplyId = '80001.1.141';
const pageNotAgreeApplyId = '80001.1.142';
const repoAgreeApplyId = '80001.1.143';
const repoNotAgreeApplyId = '80001.1.144';
// 知识库设置审批同意/不同意申请增加埋点
const repoSettingApplyId = '80001.1.145';


// 展示指定渠道强化投币气泡
const showStrengthenCoinGuidance = '80001.2.241';
// 点击指定渠道强化投币气泡关闭
const closeStrengthenCoinGuidance = '80001.2.242';
// 通过指定渠道强化投币气泡投币
const depositStrengthenCoinGuidance = '80001.2.243';
// 投币分享好文
const giveCoinShowShareDocBtn = '80001.2.255';
const giveCoinClickShareDocBtn = '80001.2.256';
const giveCoinShowShareDocDialog = '80001.2.259';
const giveCoinConfirmShareDoc = '80001.2.260';

// 点击显示封面
const showCoverRepId = '80001.1.203';
// 文档投诉入口按钮
const docComplainBtnRepId = '80001.2.288';
// 文档投诉
const docComplainRepId = '80001.2.287';

// 团队知识库首页数据表Tab点击
const repoHomeDatasheetTabReqId = '80001.4.24';

// 数据表创建视图埋点
const datasheetCreateViewRepId = '80001.8.242';

// 数据表合并表创建
const datasheetSumTableCreateId = '80001.1.358';
// 数据表合并表数据源配置更新
const datasheetSumTableUpdateId = '80001.1.360';

// 页面移动优化
const clickDocMoveId = '80001.1.227';
const bodyOverFlowRepId = '80001.2.290';

// 页面移动点击仅有知识本权限的知识库移动
const pageMoveRepId = '80001.1.232';

// 知识库价值传递-知识库设置相关
const clickRepoSettingsId = '80001.1.263';
const clickRepoSettingsTabId = '80001.4.25';
const clickInviteReaderSettingId = '80001.1.260';
const clickInviteEditorSettingId = '80001.1.261';
const clickSettingDocId = '80001.1.262';
const showInviteSettingDialogId = '80001.1.257';
const clickInviteSettingDialogCancelId = '80001.1.258';
const clickInviteSettingDialogConfirmId = '80001.1.259';
const showCopySettingDialogId = '80001.1.264';
const clickCopySettingDialogCancelId = '80001.1.265';
const clickCopySettingDialogConfirmId = '80001.1.266';

// 知识库价值传递-页面设置相关
const clickHeadShareBtnId = '80001.2.298';
const clickPublicDocBtnId = '80001.2.299';
const clickQuickShareBtnId = '80001.2.300';
const clickQuickEditorBtnId = '80001.2.301';
const clickPowerSettingBtnId = '80001.2.302';
const clickPowerApplyBtnId = '80001.2.303';
const showCloseDialogId = '80001.2.304';
const clickPowerDialogCancelBtnId = '80001.2.305';
const clickPowerDialogConfirmBtnId = '80001.2.306';
const showCloseCopyDialogId = '80001.2.307';
const clickCopyDialogCancelBtnId = '80001.2.308';
const clickCopyDialogConfirmBtnId = '80001.2.309';


// 无主知识库 页面曝光
const showNoOwnerRepoId = '80001.1.254';
// 无主知识库 点击百度流程中心
const clickFlowCenterId = '80001.1.255';
// 点击在线表格历史版本
const clickSheetHistoryRepId = '80001.1.287';
// 点击一键插入子文档列表卡
const clickInsertSubDocList = '80001.1.301';
// 展现量：插入子文档列表卡引导
const showInsertSubDocList = '80001.1.300';

// 一键拆卡提示展示
const splitCardRecommendShow = '80001.8.302';
// 一键拆卡提示展示关闭
const splitCardRecommendClose = '80001.8.300';

// 常协同组织推荐模块展示次数
const showDocRecommendGroupCountId = '80001.2.336';
// 常协同组织推荐-授权次数
const clickDocRecommendGroupCountId = '80001.2.337';
// 常协同组织推荐-查看群聊成员次数
const showDocRecommendGroupMemberId = '80001.2.338';
// 成员列表页&添加成员页-添加部门权限
const clickDocPageUpdateDepartMemberId = '80001.1.292';
// 检测到相关群聊展示次数
const showAddMemberPageRecommendGroupId = '80001.1.293';
// 点击相关群聊展示次数
const clickAddMemberPageRecommendGroupId = '80001.1.294';
// 知识库常协同组织推荐模块-展示次数
const showRepoRecommendGroupCountId = '80001.1.295';
// 知识库常协同组织推荐模块-授权次数
const clickRepoRecommendGroupCountId = '80001.1.296';
// 内链授权推荐展示
const showShareDialogRecommendPowerId = '80001.1.315';
// 内链授权推荐点击
const clickShareDialogRecommendPowerId = '80001.1.316';
// 更多内页面权限工具点击
const clickMorePowerListId = '80001.1.317';
// 内链批量授权 - 实际授权
const clickPowerModalConfirmId = '80001.1.318';
// token 重试异常上报
const tokenRetryErrorRepId = '80001.2.347';
const tokenRetryByGetKsServerRepId = '80001.2.348';

// 关闭评论侧边栏时评论未提交
const closeCommentSidebarId = '80001.8.276';

// AI知识库巡检员打开移动到弹窗
const clickOpenMoveToId = '80001.1.328';

// 点击新建知识库
const clickAddRepoId = '80001.1.340';
// 新建知识库成功
const addRepoSuccessId = '80001.1.341';

// 切换知识本类型埋点
const switchKnowledgeBookTypeId = '80001.1.342';

// 进入多选模式
const clickEnterSelectBatchId = '80001.1.345';
// 多选模式下选择文档
const clickSelectBatchDocId = '80001.1.346';
// 进入授权页面
const clickEnterPowerModalId = '80001.1.347';
// 完成实际授权
const clickAddAllPowerId = '80001.1.348';
// 快速移动到顶部
const moveToTopId = '80001.1.350';
// 快速移动到底部
const moveToBottomId = '80001.1.351';

// 点击批量复制
const clickBatchCopyBtnId = '80001.1.352';
// 批量复制浮窗展示
const showBatchDialogId = '80001.1.353';
// 无权提醒
const clickBatchNoPowerId = '80001.1.355';
// 确认复制
const clickBatchCopyId = '80001.1.354';

// 点击批量移动
const clickBatchMoveEntryId = '80001.1.361';
// 批量移动浮窗展示
const showBatchMoveDialogId = '80001.1.362';
// 无权提醒
const clickNoPowerId = '80001.1.363';
// 确认移动
const clickBatchMoveBtnId = '80001.1.364';
// 内部用户文档访问量
const clickExternalUserDocTypeId = '80001.2.364';
// 外部用户文档访问量
const clickUserDocTypeId = '80001.2.362';
// 内部用户文档编辑量
const clickExternalUserEditorId = '80001.2.365';
// 外部用户文档编辑量
const clickUserEditorId = '80001.2.363';
// 点击右下角帮助中心
const clickHelpCenterItemId = '80001.2.375';

export const repType = {
    Click: 'click',
    Show: 'show',
};
export interface searchDetail extends BaseId {
    type?: string | number;
    title?: string;
    owner?: string;
    lastUpdateTime?: string | number;
    floorId?: number;
    posRelative?: number;
    authorityType?: string;
    url?: string;
}
export interface SearchResSingleView extends BaseId {
    type?: string | number;
    title: string;
    name?: string;
    posAbsolute: number | string;
    isClickEmptyRef?: boolean | string;
}

export interface SearchInfo {
    areaType?: string;
    historyQuery?: string;
    name?: string;
    queryId?: string;
    singleView?: SearchResSingleView;
    query?: string;
    optType?: string | number;
    optValue?: any;
    detail?: searchDetail[];
    size?: string;
    timestampFeRequest?: string;
    timestampFeResponse?: string;
    isClickEmptyRef?: boolean | string;
    title?: string;
    posAbsolute?: number | string;
    errorMsg?: number | string;
    statusCode?: string;
}
export interface PageInfo extends SearchInfo, BaseId {
    [name: string]:
        string | string[] | number | boolean | SearchResSingleView | searchDetail[] | BaseId | undefined | null;
    type?: string | number;
    tagContent?: string;
    sNumber?: string;
    sNumberShow?: string;
    tagCont?: string;
    operateName?: string;
    source?: string | string[] | null | BaseId | number;
    showTagNum?: string;
    pageCount?: string;
    position?: string | number;
    pageid?: string;
}

// eslint-disable-next-line complexity
// eslint-disable-next-line max-statements
export function transPageInfo(pageInfo?: PageInfo | null, source?: string | string[] | null) {
    if (!pageInfo) {
        return {};
    }
    const params: any = Array.isArray(pageInfo) ? [] : {};
    for (const key in pageInfo) {
        if (pageInfo.hasOwnProperty(key)) {
            let paramsItem = null;
            switch (key) {
                case 'repoId':
                    paramsItem = 'kb_id';
                    break;
                case 'groupId':
                    paramsItem = 'kb_org_id';
                    break;
                case 'docType':
                    paramsItem = 'docType';
                    break;
                default:
                    paramsItem = key.replace(/([A-Z])/g, '_$1').toLowerCase();
                    break;
            }
            const paramsItemVal = pageInfo[key];
            if (Object.prototype.toString.call(paramsItemVal).includes('Object')
            || Object.prototype.toString.call(paramsItemVal).includes('Array')
            ) {
                params[paramsItem] = transPageInfo(paramsItemVal as PageInfo);
            } else {
                params[paramsItem] = paramsItemVal;
            }
        }
    }
    return params;
}

// eslint-disable-next-line max-len
export function buriedReport(repId: string, type: string, repType: string, pageInfo?: PageInfo | null, repTimeStamp?: number) {
    const data: loggerInterface = {
        'rep_id': repId,
        'rep_type': repType,
        'rep_timestamp': repTimeStamp,
    };
    if (type) {
        data.rep_params = {
            type: type,
        };
    }
    if (pageInfo) {
        data.rep_params = {
            ...(data.rep_params || {}),
            ...transPageInfo(pageInfo),
        };
    } else {
        data.rep_params = {};
    }
    return data;
}

// 是否为测试知识库，后续删除
function getIsTestRepo() {
    const repositoryGuid = store.getCurRepository()?.repositoryGuid || '';
    return ['5Bd4-q4oq5', '0YFzmNP6k_'].includes(repositoryGuid);
}

// function openPageBuriedReport(repId: string, source?: string | string[] | null, pageInfo?: PageInfo | null) {
//     return {
//         'rep_id': repId,
//         'rep_params': {
//             ...transPageInfo({
//                 ...pageInfo,
//             }, source),
//         },
//     };
// }

interface LoggerFe extends Logger {
    up: any;
}

let FELogger: LoggerFe | null = null;

// 这里由于时序问题，使用window.isTocPage会拿到false。所以从evn里面取
const isTocPage = process.env.REACT_APP_IS_TOC === 'true';
const logUploadHost = (isHi() || isTocPage) ? 'log.im.baidu.com' : 'infoflow-log.baidu-int.com';
const baseURL = `https://${logUploadHost}/clientlog/web`;
const isOffline =
    [
        ENVIRONMENT_LEVEL.local, ENVIRONMENT_LEVEL.qa, ENVIRONMENT_LEVEL.rd,
    ].includes(process.env.REACT_APP_ENVIRONMENT || '');

isOffline && import('@/style/overwrite-yuumi.css');
function init() {
    if (FELogger) {
        return;
    }
    try {
        if (isOffline) { // 线下环境为了方便团队成员验证埋点，使用这种方式上报
            (FELogger as any) = create({
                commonParams: {
                    appName: 'so_bigdata',
                },
                axiosConfig: {
                    baseURL,
                    method: 'post',
                    withCredentials: true,
                },
                logger: {
                    retryInterval: false,
                    reportInterval: 1200,
                    closePerformace: true,
                    closeClientInfo: true,
                },
            });
            // @ts-ignore, 缺失对 css 的 declare
            void import('@baidu/infoflow-plugin-verify/libs/index.css');
            void import('@baidu/infoflow-plugin-verify').then(plugin => {
                FELogger?.use(plugin.default);
            });
        } else { // 线上和灰度环境使用原来老方式上报埋点
            FELogger = createHistory({
                commonParams: {
                    appName: 'so_bigdata',
                },
                axiosConfig: {
                    baseURL,
                    method: 'post',
                    withCredentials: true,
                },
                logger: {
                    retryInterval: false,
                    reportInterval: 1200,
                    closePerformace: true,
                    closeClientInfo: true,
                },
            });
        }
    }
    catch (err) {
        console.error('fe log error', err);
    }
}
init();

// 埋点上报增加代理
export const feLogger = kuPiper.runProxy(kuPiper.proxyNameMap.feLoggerProxy, (data: loggerInterface) => {
    try {
        if (!data.rep_timestamp) {
            data.rep_timestamp = +new Date();
        }
        if (!data.rep_type) {
            data.rep_type = repType.Click;
        }
        if (!data.rep_params) {
            delete data.rep_params;
        }
        if (!FELogger) {
            init();
        }

        // 补个weirwood上报，排查埋点丢失问题
        if (!FELogger) {
            console.error(new Error(`FELogger不存在，埋点上报失败: ${JSON.stringify(data)}, ${isOffline}`));
        }

        if (isOffline) {
            FELogger?.event(data.rep_id, data.rep_params, data.rep_type as any);
        } else {
            FELogger?.up(data);
        }
    }
    catch (err) {
        console.error('felogger error');
    }
});

export const logger = (repId: string, type: string, params?: any) => {
    try {
        const data = {
            rep_id: repId,
            rep_type: type,
            rep_params: params,
        };
        if (!params) {
            delete data.rep_params;
        }
        feLogger(data);
    } catch (e) {
        console.error(e);
    }
};

export const feLoggerSetUid = (uid: string) => {
    FELogger?.setCommonParam('uid', uid);
};

export function getSource() {
    if (isInKuShare()) {
        return SourceType.kuShare;
    }
    const {source = SourceType.url} = store.getUrlQuery();
    return source;
}

// 当用户关闭浏览器、刷新浏览器或者跳转其他页面时，使用navigator.sendBeacon上报。
export function feSendBeaconLogger(rep_id: string, rep_params: Record<string, any>, rep_type: string) {
    const content = createContentWrap('buryPointInfo', {
        rep_id,
        rep_params,
        rep_type,
    });
    const body = createReportBody.call(FELogger!, [content]);
    // 兼容处理：对于不存在sendBeacon方法的浏览器，使用xhr兜底
    if (navigator.sendBeacon) {
        const blob = new Blob([JSON.stringify(body)], {
            type: 'text/plain; charset=UTF-8',
        });
        navigator.sendBeacon(baseURL, blob);
    } else {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', baseURL);
        xhr.send(JSON.stringify(body));
    }
}

function getUrlSource() {
    const {source = SourceType.url} = store.getUrlQuery();
    return source;
}

// MARKS:
// 文档分享协作
const ShareRepObj = {
    shareinviteBtn: '80001.1.31',
    share: '80001.1.32',
    invite: '80001.1.33',
};
export const shareInviteFeLogger = buriedReport(ShareRepObj.shareinviteBtn, '', repType.Click);

// 文档页面浏览状态切换上报
export const docPageActiveChange = (repId: string, repParams: Record<string, any>, repType: string) => {
    feSendBeaconLogger(repId, {
        ...repParams,
        source: getSource(), // todo: 这里看看是不是只拦截上报知识助手过来的
    }, repType);
};

// 文档分享邀请
export const docShareInvite = (type: EnumShareInviteType, num: number) => {
    const repId = ShareRepObj[type];
    return buriedReport(repId, '', repType.Click, {num});
};

// 页面分享
export const pageShare = buriedReport(shareRepId, '1', repType.Click);
// 知识库分享
export const repositoryShare = buriedReport(shareRepId, '2', repType.Click);
// 点击分享按钮
export const clickShareBtn = (pageInfo?: PageInfo | null) => {
    return buriedReport(shareRepId, '', repType.Click, pageInfo);
};

// 删除空间
export const deleteRepository = buriedReport(deleteRepId, '1', repType.Click);
// 删除页面
export const deletePage = buriedReport(deleteRepId, '2', repType.Click);

// 演示模式
export const demonstration = buriedReport(demonstrationRepId, '', repType.Click);

// 恢复历史版本-暂无
// export const restoreHistory = buriedReport(restoreHistoryRepId, '', repType.Click);

/*  暂无
// 插件-图片插入
export const insertImage = buriedReport(pluginRepId, '1', repType.Click);
// 插件-文件插入
export const insertFile = buriedReport(pluginRepId, '2', repType.Click);
// 插件-公式
export const formula = buriedReport(pluginRepId, '3', repType.Click);
// 插件-代码块
export const codeBlock = buriedReport(pluginRepId, '4', repType.Click);
// 插件-表格
export const table = buriedReport(pluginRepId, '5', repType.Click);
// 插件-@其他人
export const atOthers = buriedReport(pluginRepId, '6', repType.Click);
// 插件-markdown
export const markdown = buriedReport(pluginRepId, '7', repType.Click);
*/

// 彻底删除空间 -暂无
// export const shredRepository = buriedReport(shredRepId, '1', repType.Click);

// 彻底删除页面
export const shredPage = buriedReport(shredRepId, '2', repType.Click);

// 移除页面权限
export const removePageMember = buriedReport(removeMemberRepId, '1', repType.Click);
// 移除空间权限
export const removeRepositoryMember = buriedReport(removeMemberRepId, '2', repType.Click);

// 打开页面, @todo 目前木有如流跳转
// export const openPage = openPageBuriedReport(openPageRepId, '1', repType.Click);
export const openPageUrl = (pageInfo?: PageInfo | null) => {
    if (window.isTocPage) {
        return;
    }
    return buriedReport(openPageRepId, '', repType.Click, {
        ...pageInfo,
        source: getUrlSource(),
        type: isInKuShare() ? 'kuShare' : undefined,
        userAgent: window.navigator.userAgent,
    });
};

export const openBaiekPageUrl = (pageInfo?: PageInfo | null) => {
    return buriedReport(openBaikePageReportId, '', repType.Click, {
        ...pageInfo,
        source: getSource(),
    });
};

// 进入首页, @todo 目前木有如流跳转
// export const openHomeInRuLiu = openPageBuriedReport(openHomeRepId, '1');
export const openHomeUrl = () => {
    if (window.isTocPage) {
        return;
    }
    return buriedReport(openHomeRepId, '', repType.Click);
};

// 进入空间, @todo 目前木有如流跳转
// export const openRepositoryInRuLiu = openPageBuriedReport(openRepositoryRepId, '1');
export const openRepositoryUrl = (pageInfo?: PageInfo | null) => {
    if (window.isTocPage) {
        return;
    }
    return buriedReport(openRepositoryRepId, '', repType.Click, {...pageInfo, source: getSource()});
};

// 打开如流对话
export const openRLDialog = (pageInfo?: PageInfo | null) => {
    return buriedReport(openRLDialogId, '', repType.Click, pageInfo);
};


// 编辑
export const editDocument = (pageInfo?: PageInfo | null) => {
    return buriedReport(editDocumentId, '', repType.Click, pageInfo);
};
// 编辑按钮
// export const pageEdit = buriedReport(editRepId, '', repType.Click);
export const pageEdit = (pageInfo?: PageInfo | null) => {
    if (window.isTocPage) {
        return;
    }
    return buriedReport(editRepId, '', repType.Click, pageInfo);
};
// 发布按钮
export const publish = (pageInfo?: PageInfo | null) => {
    return buriedReport(publishRepId, '', repType.Click, pageInfo);
};
// 左侧导航主页按钮
export const openHomeInTree = buriedReport(openHomeInTreeRepId, '', repType.Click);
// // 左侧导航文档按钮
// export const openPageInTree = buriedReport(openPageInTreeRepId, '', repType.Click);
// 左侧导航设置按钮
export const openSetting = buriedReport(openSettingRepId, '', repType.Click);
// 左侧导航回收站按钮
export const openRecycleBin = buriedReport(openRecycleBinRepId, '', repType.Click);
// 点击如流知识库tab
export const openHomePage = buriedReport(clickHomeIconId, '', repType.Click);
// 点击我的部门
export const openMyDepartment = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickMyDepartmentId, '', repType.Click, pageInfo);
};
// 点击一个我星标的知识库
export const openMyFavoriteKu = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickMeFollowKuId, '', repType.Click, pageInfo);
};
// 点击一个星标的页面
export const openMyFavoritePage = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickMeFollowPageId, '', repType.Click, pageInfo);
};
// 点击一个最近浏览的页面
export const openMyRecentPage = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickRecentBrowsingPageId, '', repType.Click, pageInfo);
};
// 点击一个我最近浏览的知识库
export const openMyRecentku = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickRecentBrowsingKuId, '', repType.Click, pageInfo);
};

// 点击部门知识库tab
export const openDepartmentTab = (pageInfo?: PageInfo | null) => {
    return buriedReport(openDepartmentTabId, '', repType.Click, pageInfo);
};

// 点击部门首页添加推荐按钮
export const recommendRepoAddBtn = buriedReport(clickRecommendRepoAddBtn, '', repType.Click);
// 点击部门首页推荐知识库的置顶按钮
export const recommendRepoTopBtn = buriedReport(clickRecommendRepoTopBtn, '', repType.Click);
// 点击部门首页推荐知识库的移除按钮
export const recommendRepoDelBtn = buriedReport(clickRecommendRepoDelBtn, '', repType.Click);
// 点击部门首页推荐知识库的移除按钮
export const dataOverviewAll = buriedReport(clickDataOverviewAllBtn, '', repType.Click);

// 星标部门
export const followedDepartment = (pageInfo?: PageInfo) => {
    return buriedReport(followDepartmentId, '', repType.Click, pageInfo);
};
// 取消星标部门
export const cancelFollowedDepartment = buriedReport(cancelFollowDepartmentId, '', repType.Click);
// 分享部门
export const shareDepartment = buriedReport(shareDepartmentId, '', repType.Click);
// 删除标签
export const deleteDepartmentTag = buriedReport(departmentDeleteTagId, '', repType.Click);

// 标签聚合
// 标签点击
export const tagClickRep = (pageInfo?: PageInfo | null) => {
    return buriedReport(tagClickRepId, '', repType.Click, pageInfo);
};
// 删除标签
export const deleteTagRep = (pageInfo?: PageInfo | null) => {
    return buriedReport(deleteTagRepId, '', repType.Click, pageInfo);
};
// 标签入口点击
export const entryTagRep = (pageInfo?: PageInfo | null) => {
    return buriedReport(entryTagRepId, '', repType.Click, pageInfo);
};
// 标签目录点击
export const catalogueTagRep = (pageInfo?: PageInfo | null) => {
    return buriedReport(catalogueTagRepId, '', repType.Click, pageInfo);
};
// 标签聚合页点击
export const togetherTagRep = (pageInfo?: PageInfo | null) => {
    return buriedReport(togetherTagRepId, '', repType.Click, pageInfo);
};
// openPage-推荐标签数量
export const openPageTagRep = (pageInfo?: PageInfo | null) => {
    return buriedReport(openPageTagRepId, '', repType.Click, pageInfo);
};
// 标签聚合页更多标签点击
export const moreTagClickRep = (pageInfo?: PageInfo | null) => {
    return buriedReport(moreTagClickRepId, '', repType.Click, pageInfo);
};
// 企业百科标签点击
export const baikeTagClickRep = (pageInfo?: PageInfo | null) => {
    return buriedReport(baikeTagClickRepId, '', repType.Click, pageInfo);
};
// 企业百科分类标签点击包括首页和目录
export const baikeTagNewClickRep = (pageInfo?: PageInfo | null) => {
    return buriedReport(baikeTagNewClickRepId, '', repType.Click, pageInfo);
};
// 点击企业百科分类标签展开
export const openBaikeTagRep = (pageInfo?: PageInfo | null) => {
    return buriedReport(openBaikeTagRepId, '', repType.Click, pageInfo);
};
// 点击企业百科分类标签翻页
export const turnPagesBaikeTagRep = (pageInfo?: PageInfo | null) => {
    return buriedReport(turnPagesBaikeTagRepId, '', repType.Click, pageInfo);
};
// 点击企业百科分类标签翻页
export const baikeEntryClickRep = (pageInfo?: PageInfo | null) => {
    return buriedReport(baikeEntryClickRepId, '', repType.Click, pageInfo);
};
// openPage-贡献词条
export const opepnContributeRep = (pageInfo?: PageInfo | null) => {
    return buriedReport(opepnContribute, '', repType.Click, pageInfo);
};


// 创建标签
export const createDepartmentTag = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentCreateTagId, '', repType.Click, pageInfo);
};
// 首页-简介-编辑
export const departmentHomeEditintroduction = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentHomeEditintroductionId, '', repType.Click, pageInfo);
};
// 首页--简介查看详情
export const departmentViewDetail = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentViewDetailId, '', repType.Click, pageInfo);
};
// 首页--公告编辑
export const departmentEditNotice = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentEditNoticeId, '', repType.Click, pageInfo);
};
// 首页--热门知识库
export const departmentHotKu = buriedReport(departmentHotKuId, '', repType.Click);
// 首页--留言板发布
export const departmentMessageBoardRelease = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentMessageBoardReleaseId, '', repType.Click, pageInfo);
};
// 首页--留言板回复
export const departmentMessageBoardReply = buriedReport(departmentMessageBoardReplyId, '', repType.Click);
// 首页--留言板删除
export const departmentMessageBoardDelete = buriedReport(departmentMessageBoardDeleteId, '', repType.Click);
// 首页--外部知识库推荐-添加
export const departmentOutKuRecommendAdd = buriedReport(departmentOutKuRecommendAddId, '', repType.Click);
// 首页--外部知识库-删除
export const departmentOutKuRecommendDelete = buriedReport(departmentOutKuRecommendDeleteId, '', repType.Click);
// 首页--热门知识库--打开知识库
export const departmentHotKuOpenKu = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentHotKuOpenKuId, '', repType.Click, pageInfo);
};
// 首页-外部知识库-打开知识库
export const departmentOutKuOpenKu = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentOutKuOpenKuId, '', repType.Click, pageInfo);
};
// 知识库-打开知识库
export const departmentkuListOpenKu = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentkuListOpenKuId, '', repType.Click, pageInfo);
};
// 首页-公告-查看全部
export const departmentHomeNoticeViewAll = buriedReport(departmentHomeNoticeViewAllId, '', repType.Click);
// 点击搜索
export const clickSearch = buriedReport(clickSearchId, '', repType.Click);
// 搜索后点击页面
export const searchClickPage = (pageInfo?: PageInfo | null) => {
    return buriedReport(searchClickPageId, '', repType.Click, pageInfo);
};
// 搜索后点击知识库
export const searchClickKu = (pageInfo?: PageInfo | null) => {
    return buriedReport(searchClickKuId, '', repType.Click, pageInfo);
};
// 点击我的知识库
export const clickMyKu = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickMyKuId, '', repType.Click, pageInfo);
};
// 进入部门知识库
export const enterDepartment = (pageInfo?: PageInfo | null) => {
    return buriedReport(enterDepartmentId, '', repType.Click, {...pageInfo, source: getSource()});
};

// 搜索推荐标签
export const searchRecommendTag = (pageInfo?: PageInfo | null) => {
    return buriedReport(searchRecommendTagId, '', repType.Show, pageInfo);
};

// 添加的标签类别，添加标签的是手动输入或机器推荐标签
export const addTagType = (pageInfo?: PageInfo | null) => {
    return buriedReport(addTagTypeId, '', repType.Click, pageInfo);
};

// 文档点赞
export const documentLike = (pageInfo?: PageInfo | null) => {
    return buriedReport(documentLikeClick, '', repType.Click, pageInfo);
};
// 文档评论
export const documentComment = (pageInfo?: PageInfo | null) => {
    if (getIsSdkPage()) {
        return buriedReport(documentCommentSdkClick, '', repType.Click, {
            ...pageInfo,
            id: (window as any).sdkToken,
        });
    }
    return buriedReport(documentCommentClick, '', repType.Click, pageInfo);
};
// 文档协作确定按钮
export const documentCooperation = (pageInfo?: PageInfo | null) => {
    return buriedReport(documentCooperationClick, '', repType.Click, pageInfo);
};
// 长时间预览文档上报埋点
export const longBrowsingTimeReport = (pageInfo?: PageInfo | null) => {
    return buriedReport(longBrowsingTimeId, '', repType.Show, pageInfo);
};
// hover展现创建者卡片
export const showCreatorReport = (pageInfo?: PageInfo | null) => {
    return buriedReport(showCreatorId, '', repType.Show, pageInfo);
};
// 在创建者卡片点击头像进入个人主页
export const clickCreatorReport = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickCreatorId, '', repType.Click, pageInfo);
};

// 最近预览hover
export const recentBrowseRecordsHover = buriedReport(hoverRecentBrowseRecords, '', repType.Click);
// 最近预览点击缩略卡片
export const recentBrowseRecordsClick = buriedReport(clickRecentBrowseRecords, '', repType.Click);
// 最近预览点击开关
export const recentBrowseRecordsSwitchClick = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickRecentBrowseRecordsSwitch, '', repType.Click, pageInfo);
};

export const rteReport = (repId: string, data: any) => {
    feLogger({
        'rep_type': 'click',
        'rep_timestamp': +new Date(),
        'rep_id': repId,
        'rep_params': data,
    });
};
// 新建页面
export const clickNewBuildPage = (pageInfo?: PageInfo) => {
    return buriedReport(newBuildPageId, '', repType.Click, pageInfo);
};

// 部门知识库相关埋点
// 点击分享后的复制链接tab(部门知识库）
export const clickShareModalCopeLink = (type: PageType, pageInfo?: PageInfo) => {
    return buriedReport(shareCopeLinkId, type, repType.Click, pageInfo);
};

// 点击分享后的分享tab(部门知识库)
export const clickShareModalBtn = (type: PageType, pageInfo?: PageInfo) => {
    return buriedReport(shareBtnId, type, repType.Click, pageInfo);
};

// 外部知识库/部门收藏夹-去添加-点击确定(PC)
export const clickOutOrDepartmentModalConfirm = buriedReport(outOrDepartmentKBConfirmId, '', repType.Click);

// 外部知识库/部门收藏夹-删除-点击确定(PC)
export const clickRemoveOutOrDepartment = buriedReport(removeOutOrDepartmentId, '', repType.Click);

// 展示部门知识库首页
export const departmentIndex = (pageInfo?: PageInfo | null) => {
    return buriedReport(showDepartmentIndexId, '', repType.Show, pageInfo);
};

// 展示部门知识库统计页
export const departmentStatistics = (pageInfo?: PageInfo | null) => {
    return buriedReport(showStatistics, '', repType.Click, pageInfo);
};

// 进入部门知识库首页中的知识库
export const enterDepartmentRepository = (pageInfo?: PageInfo) => {
    return buriedReport(enterDepartmentRepositoryId, '', repType.Click, pageInfo);
};

// 进入部门知识库中的成员
export const enterDepartmentMembers = (pageInfo?: PageInfo) => {
    return buriedReport(enterDepartmentMembersId, '', repType.Click, pageInfo);
};

// 进入部门知识库中的设置页面
export const enterDepartmentSetting = (pageInfo?: PageInfo) => {
    return buriedReport(enterDepartmentSettingId, '', repType.Click, pageInfo);
};

// 进入部门知识库中的回收站页面
export const enterDepartmentRecycle = (pageInfo?: PageInfo) => {
    return buriedReport(enterDepartmentRecycleId, '', repType.Click, pageInfo);
};

// 进入部门知识库简介页面
export const enterDepartmentIntroduction = (pageInfo?: PageInfo) => {
    return buriedReport(enterDepartmentIntroductionId, '', repType.Click, pageInfo);
};

// 进入留言板页面
export const enterDepartmentMessage = (pageInfo?: PageInfo) => {
    return buriedReport(enterDepartmentMessageId, '', repType.Click, pageInfo);
};

// 复制短链接
export const reportCopyShortLink = ({type}: {
    // 1：文档，2：知识本，3：知识库，4：表格，5：部门，6：PPT
    type?: IDocType | 3 | 5;
}) => {
    return buriedReport(copyShortLinkId, '', repType.Click, {type: type || 1});
};

// 快捷授权弹窗
export const reportQuickAuthorizePopper = (options: any) => {
    return feLogger({
        rep_id: quickAuthorizePopperId,
        rep_type: 'show',
        rep_params: {
            ...options,
        },
    });
};

// 快捷授权弹窗-授权按钮
export const reportQuickAuthorizeBtn = (options: any) => {
    return feLogger({
        rep_id: quickAuthorizeBtnId,
        rep_type: 'click',
        rep_params: {
            ...options,
        },
    });
};

// 点击开启会议按钮
export const reportStartMeetingBtn = (options: any) => {
    return feLogger({
        rep_id: startMeetingBtnId,
        rep_type: 'click',
        rep_params: {
            ...options,
        },
    });
};

// 点击结束会议按钮
export const reportStopMeetingBtn = (options: any) => {
    return feLogger({
        rep_id: stopMeetingBtnId,
        rep_type: 'click',
        rep_params: {
            ...options,
        },
    });
};

// 发送强化通知
export const reportSendNotifyToMentions = (options: any) => {
    return feLogger({
        rep_id: sendNotifyToMentionsId,
        rep_type: 'click',
        rep_params: {
            ...options,
        },
    });
};

// 星链入口展示
export const reportRobotStarlinkRepId = (options: any) => {
    return buriedReport(robotStarlinkRepId, '', repType.Click, options);
};

// hover星链入口展示
export const reportHoverRobotStarlinkRepId = (options: any) => {
    return buriedReport(hoverRobotStarlinkRepId, '', repType.Click, options);
};

// 点击ICafe卡片
export const reportClickICafeCard = (options: any) => {
    return feLogger({
        rep_id: clickICafeCardId,
        rep_type: 'click',
        rep_params: {
            ...options,
        },
    });
};

// 关联ICafe卡片
export const reportRelatedICafeCard = (options: any) => {
    return feLogger({
        rep_id: relatedICafeCardId,
        rep_type: 'click',
        rep_params: {
            ...options,
        },
    });
};

// 取消关联IApi文档
export const cancelIApi = (options: any) => {
    return feLogger({
        rep_id: cancelIApiId,
        rep_type: 'click',
        rep_params: {
            ...options,
        },
    });
};

// 点击会议卡片
export const reportClickMeetings = (options: any) => {
    return feLogger({
        rep_id: clickMeetingsId,
        rep_type: 'click',
        rep_params: {
            ...options,
        },
    });
};
// hover会议卡片
export const reportHoverMeetings = (options: any) => {
    return feLogger({
        rep_id: hoverMeetingsId,
        rep_type: 'click',
        rep_params: {
            ...options,
        },
    });
};
// 知识库搜索
// 空框搜索
export const clickRecentArea = (pageInfo?: PageInfo) => {
    return buriedReport(clickRecentAreaId, '', repType.Click, pageInfo);
};
// 输入框有内容时，点击单条内容
export const clickSearchListItem = (pageInfo?: PageInfo) => {
    return buriedReport(clickSearchListItemId, '', repType.Click, pageInfo);
};
// 输入框有内容时触发搜索
export const inputSearch = (pageInfo?: PageInfo) => {
    return buriedReport(inputSearchId, '', repType.Click, pageInfo);
};
// 搜索结果展示
export const searchResultShow = (pageInfo?: PageInfo) => {
    return buriedReport(searchResultShowId, '', repType.Click, pageInfo);
};
// 输入框有内容时对搜索结果的操作
export const searchResultOperate = (pageInfo?: PageInfo) => {
    return buriedReport(searchResultOperateId, '', repType.Click, pageInfo);
};
// 下滑加载过程
export const pulldownLoadMore = (pageInfo?: PageInfo) => {
    return buriedReport(pulldownLoadMoreId, '', repType.Click, pageInfo);
};
// 搜索接口异常
export const searchAPIError = (pageInfo?: PageInfo) => {
    return buriedReport(searchAPIErrorId, '', repType.Click, pageInfo);
};

// 提及
export const mention = (pageInfo?: PageInfo) => {
    return buriedReport(mentionId, '', repType.Click, pageInfo);
};

// 点击头像，同步视窗
export const clickAvatarSyncView = (pageInfo?: PageInfo) => {
    return buriedReport(clickAvatarSyncViewId, '', repType.Click, pageInfo);
};

// 点击历史版本按钮
export const reportClickHistoryVersion = (pageInfo?: PageInfo) => {
    return buriedReport(clickHistoryVersionId, '', repType.Click, pageInfo);
};

// 文档域 文章页面
// 展开引用
export const expandReference = (pageInfo?: PageInfo | null) => {
    return buriedReport(expandReferenceId, '', repType.Click, pageInfo);
};

// 点击引用文档
export const clickDocReference = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickDocReferenceId, '', repType.Click, pageInfo);
};

// 打开文档
export const openDocShowReference = (pageInfo?: PageInfo | null) => {
    return buriedReport(openDocShowReferenceId, '', repType.Click, pageInfo);
};

// 推荐文档阅读展现
export const openShowRecommendReading = (pageInfo?: PageInfo | null) => {
    return buriedReport(openShowRecommendReadingId, '', repType.Click, pageInfo);
};

// 点击推荐文档
export const clickRecommendReading = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickRecommendReadingId, '', repType.Click, pageInfo);
};

// 推荐文档翻页
export const turnPagesRecommendReading = (pageInfo?: PageInfo | null) => {
    return buriedReport(turnPagesRecommendReadingId, '', repType.Click, pageInfo);
};

// 关闭推荐
export const closeRecommendReading = (pageInfo?: PageInfo | null) => {
    return buriedReport(closeRecommendReadingId, '', repType.Click, pageInfo);
};

// 关注文档
export const flowDocument = (pageInfo?: PageInfo | null) => {
    return buriedReport(flowDocumentId, '', repType.Click, pageInfo);
};
// 关注/取消关注文档更新
export const flowDocumentUpdate = (pageInfo?: PageInfo | null) => {
    return buriedReport(flowDocumentUpdateId, '', repType.Click, pageInfo);
};
// 关注/取消关注文档评论
export const flowDocumentComment = (pageInfo?: PageInfo | null) => {
    return buriedReport(flowDocumentCommentId, '', repType.Click, pageInfo);
};
// 关注/取消关注文档分享
export const flowDocumentPermission = (pageInfo?: PageInfo | null) => {
    return buriedReport(flowDocumentPermissionId, '', repType.Click, pageInfo);
};

// 设置-智能推荐
export const clickSetting = (id: ClickSettingType, pageInfo?: PageInfo | null) => {
    return buriedReport(id, '', repType.Click, pageInfo);
};

export const rteWebLog = ({id, data}: {id: string, data: any}) => {
    feLogger({
        rep_id: id,
        rep_type: repType.Click,
        rep_params: {...data},
    });
};

export const editorTemplate = (pageInfo?: PageInfo | null) => {
    return buriedReport(editorTemplateReadingId, '', repType.Click, pageInfo);
};

// 用户人员搜索使用(分享 添加成员 正文内@ 划线评论内@)
export const searchScene = (pageInfo?: PageInfo | null) => {
    return buriedReport(searchSceneId, '', repType.Click, pageInfo);
};

// 用户人员搜索点击(分享 添加成员 正文内@ 划线评论内@)
export const searchClickScene = (pageInfo?: PageInfo | null) => {
    return buriedReport(searchClickSceneId, '', repType.Click, pageInfo);
};
// @群聊使用量
export const clickMentionGroup = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickMentionGroupId, '', repType.Click, pageInfo);
};

// 创建知识本
export const createBook = (pageInfo?: PageInfo | null) => {
    return buriedReport(createBookId, '', repType.Click, pageInfo);
};

// 打开知识本
export const openBook = (pageInfo?: PageInfo | null) => {
    return buriedReport(openBookId, '', repType.Click, pageInfo);
};

// 操作知识本
export const bookOperate = (pageInfo?: PageInfo | null) => {
    return buriedReport(bookOperateId, '', repType.Click, pageInfo);
};
// 文档公开
export const docPublic = (pageInfo?: PageInfo | null) => {
    return buriedReport(docPublicId, '', repType.Click, pageInfo);
};
// 文档公开赋权
export const docPublicEmpowerment = (pageInfo?: PageInfo | null) => {
    return buriedReport(docPublicEmpowermentId, '', repType.Click, pageInfo);
};
// 进入添加成员弹窗
export const enterAddMemberModal = (pageInfo?: PageInfo | null) => {
    return buriedReport(enterAddMemberModalId, '', repType.Click, pageInfo);
};
// 添加成员
export const addMember = (pageInfo?: PageInfo | null) => {
    return buriedReport(addMemberId, '', repType.Click, pageInfo);
};
// 进入文档/知识本成员列表弹窗
export const enterPageMemberListModal = (pageInfo?: PageInfo | null) => {
    return buriedReport(enterPageMemberListModalId, '', repType.Click, pageInfo);
};
// 进入数据表权限设置面板
export const enterDatasheetPermSettingPanel = (pageInfo?: PageInfo | null) => {
    return buriedReport(datasheetPermSettingShowId, '', repType.Show, pageInfo);
};
// 在文档/知识本成员列表弹窗修改成员权限
export const pageMemberListUpdatePermission = (pageInfo?: PageInfo | null) => {
    return buriedReport(pageMemberListUpdatePermissionId, '', repType.Click, pageInfo);
};
// 进入分享到如流浮层
export const enterShareToRuLiuPopper = (pageInfo?: PageInfo | null) => {
    return buriedReport(enterShareToRuLiuPopperId, '', repType.Click, pageInfo);
};
// 分享到如流
export const shareCardToRuLiu = (pageInfo?: PageInfo | null) => {
    return buriedReport(shareToRuLiuId, '', repType.Click, pageInfo);
};
// 划选字数统计
export const selectionWordCount = (pageInfo?: PageInfo | null) => {
    return buriedReport(selectionWordCountId, '', repType.Click, pageInfo);
};

export const triggerEditHotKey = () => {
    return buriedReport(editHotKeyId, '', repType.Click);
};

export const triggerPublishHotKey = () => {
    return buriedReport(publishHotKeyId, '', repType.Click);
};

export const lineationCommentShareBtnClick = (pageInfo?: PageInfo | null) => {
    return buriedReport(lineationCommentShareBtnClickRepId, '', repType.Click, pageInfo);
};

export const lineationCommentShare = (pageInfo?: PageInfo | null) => {
    return buriedReport(lineationCommentShareRepId, '', repType.Click, pageInfo);
};

export const openRightComment = (pageInfo?: PageInfo | null) => {
    return buriedReport(openRightCommentRepId, '', repType.Click, pageInfo);
};

// 文档页面 visibilitychange
export const docPageVisibility = (pageInfo?: PageInfo | null) => {
    return buriedReport(docPageVisibilityRepId, '', repType.Show, {
        ...pageInfo,
        source: getSource(),
    });
};

// 文档页面 focus
export const docPageFocus = (pageInfo?: PageInfo | null) => {
    return buriedReport(docPageFocusRepId, '', repType.Click, {
        ...pageInfo,
        source: getSource(),
    });
};

// 文档页面 Ku享websocket断连
export const kuShareWsErrorReport = (pageInfo?: PageInfo | null) => {
    return buriedReport(docKuShareWsErrorId, '', repType.Show, pageInfo);
};

// 文档页面 Ku享websocket重连
export const kuShareWsReconnectReport = (pageInfo?: PageInfo | null) => {
    return buriedReport(docKuShareWsReconnectId, '', repType.Show, pageInfo);
};

// 文档页面 Ku享websocket数据后端报错
export const kuShareWsDataErrorReport = (pageInfo?: PageInfo | null) => {
    return buriedReport(docKuShareWsDataErrorId, '', repType.Show, pageInfo);
};

// 以下是为了协助研发定位ku享问题新增的埋点
// ku享-pv：记录用户进入时间 - 用于排查白屏
export const openKuShare = (pageInfo?: PageInfo | null) => {
    return buriedReport(openKuShareId, '', repType.Show, pageInfo);
};

// ku享-点击跟随按钮
export const clickFollowButton = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickFollowButtonId, '', repType.Show, pageInfo);
};

// ku享-触发取消跟随
export const onCancelFollow = (pageInfo?: PageInfo | null) => {
    return buriedReport(onCancelFollowId, '', repType.Show, pageInfo);
};

// ku享-ws消息队列累积超过10条
export const wsMsgBacklog = (pageInfo?: PageInfo | null) => {
    return buriedReport(wsMsgBacklogId, '', repType.Show, pageInfo);
};

// ku享-创建ws失败，用户信息获取失败，websocket握手失败
export const createWsFailed = (pageInfo?: PageInfo | null) => {
    return buriedReport(createWsFailedId, '', repType.Show, pageInfo);
};

// ku享-ws重连次数大于5
export const wsReconnectTooMore = (pageInfo?: PageInfo | null) => {
    return buriedReport(wsReconnectTooMoreId, '', repType.Show, pageInfo);
};

// ku享-心跳包失效，触发重连
export const wsHeartbeatFailed = (pageInfo?: PageInfo | null) => {
    return buriedReport(wsHeartbeatFailedId, '', repType.Show, pageInfo);
};

// ku享-发送数据时检测到kuShareWs不存在
export const wsNotFound = (pageInfo?: PageInfo | null) => {
    return buriedReport(wsNotFoundId, '', repType.Show, pageInfo);
};

// ku享-应用视角数据出错
export const setSnapshotFailed = (pageInfo?: PageInfo | null) => {
    return buriedReport(setSnapshotFailedId, '', repType.Show, pageInfo);
};

// ku享-点击跟随按钮，拿到url为空
export const followUrlNotFound = (pageInfo?: PageInfo | null) => {
    return buriedReport(followUrlNotFoundId, '', repType.Show, pageInfo);
};

// ku享-端window.BdHiJs.service.meeting调用抛错
export const jsSdkMetingError = (pageInfo?: PageInfo | null) => {
    return buriedReport(jsSdkMetingErrorId, '', repType.Show, pageInfo);
};

// ku享-onBdHiJsReady和onLoad的时间差上报
export const bdHiJsDiffTime = (pageInfo?: PageInfo | null) => {
    return buriedReport(bdHiJsDiffTimeId, '', repType.Show, pageInfo);
};

// ku享-pv
export const kuSharePv = (pageInfo?: PageInfo | null) => {
    return buriedReport(kuSharePvId, '', repType.Show, pageInfo);
};

// ku享-bdHiJs加载超时
export const bdHiJsTimeout = (pageInfo?: PageInfo | null) => {
    return buriedReport(bdHiJsTimeoutId, '', repType.Show, pageInfo);
};


// 从客户端导入 Excel
export const importExcelFromClient = (pageInfo?: PageInfo | null) => {
    return buriedReport(importExcelFromClientRepId, '', repType.Click, pageInfo);
};

// 从 Web 端导入 Excel
export const importExcelFromWeb = (pageInfo?: PageInfo | null) => {
    return buriedReport(importExcelFromWebRepId, '', repType.Click, pageInfo);
};

// 从 Web 端导入 Excel（数据表）
export const importExcelDstFromWeb = (pageInfo?: PageInfo | null) => {
    return buriedReport(importExcelDstFromWebRepId, '', repType.Click, pageInfo);
};

// 从 Web 端导入 PPT
export const importPPTFromWeb = (pageInfo?: PageInfo | null) => {
    return buriedReport(importPPTFromWebRepId, '', repType.Click, pageInfo);
};

// 从 Web 端导入 Word
export const importWordFromWeb = (pageInfo?: PageInfo | null) => {
    return buriedReport(importWordFromWebRepId, '', repType.Click, pageInfo);
};

// 从 Web 端导入 PDF
export const importPDFFromWeb = (pageInfo?: PageInfo | null) => {
    return buriedReport(importPDFFromWebRepId, '', repType.Click, pageInfo);
};

// 导出 PPT
export const exportPPTReport = (pageInfo?: PageInfo | null) => {
    return buriedReport(exportPPTRepId, '', repType.Click, pageInfo);
};

// 导出 Excel（数据表）
export const exportExcelDstReport = (pageInfo?: PageInfo | null) => {
    return buriedReport(exportExcelDstRepId, '', repType.Click, pageInfo);
};

// 播放/退出播放 PPT
export const playPPT = (pageInfo?: PageInfo | null) => {
    return buriedReport(playPPTRepId, '', repType.Click, pageInfo);
};

// 知识本继承知识库权限缩小
export const bookPageInherit = (pageInfo?: PageInfo | null) => {
    return buriedReport(bookPageInheritId, '', repType.Click, pageInfo);
};
// 打印/导出PDF
export const printExport = (pageInfo?: PageInfo | null) => {
    return buriedReport(printExportId, '', repType.Click, pageInfo);
};
// 打印/导出PDF携带目录
export const printPDFCarryDirectory = (pageInfo?: PageInfo | null) => {
    return buriedReport(printPDFCarryDirectoryId, '', repType.Click, pageInfo);
};
// 打印/导出PDF携带目录
export const printPDFNoCarryDirectory = (pageInfo?: PageInfo | null) => {
    return buriedReport(printPDFNoCarryDirectoryId, '', repType.Click, pageInfo);
};
// 部门打开新手引导视频
export const departmentOpenVideo = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentOpenVideoId, '', repType.Show, pageInfo);
};

// 部门播放新手引导视频
export const departmentPlayVideo = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentPlayVideoId, '', repType.Click, pageInfo);
};
// 激活搜索
export const activeSearch = buriedReport(activeSearchId, '', repType.Click);
// 点击落地页入口
export const clickSearchPageEntry = (pageInfo?: PageInfo) => {
    return buriedReport(clickSearchPageEntryId, '', repType.Click, pageInfo);
};
// 点击落地页搜索结果或者最近浏览
export const clickListItemFromSearchPage = (pageInfo?: PageInfo) => {
    return buriedReport(clickListItemFromSearchPageId, '', repType.Click, pageInfo);
};
// 点击搜索落地页的热点知识榜
export const clickHotKnowledge = (pageInfo?: PageInfo) => {
    return buriedReport(clickHotKnowledgeId, '', repType.Click, pageInfo);
};
// 落地页发起搜索
export const searchFromSearchPage = (pageInfo?: PageInfo) => {
    return buriedReport(searchId, '', repType.Click, pageInfo);
};
// 搜索落地页翻页
export const pageTurnFromSearchPage = buriedReport(pageTurnId, '', repType.Click);
// 搜索落地页实时推荐sug展示
export const showRecommendQuery = (pageInfo?: PageInfo) => {
    return buriedReport(showRecommendQueryId, '', repType.Show, pageInfo);
};
// 搜索落地页sug点击
export const clickRecommendQuery = (pageInfo?: PageInfo) => {
    return buriedReport(clickRecommendQueryId, '', repType.Click, pageInfo);
};
// 搜索落地页筛选
export const filterChange = (pageInfo?: PageInfo) => {
    return buriedReport(filterId, '', repType.Click, pageInfo);
};
// 搜索落地页右侧推荐区分发
export const relatedPerson = (pageInfo?: PageInfo) => {
    return buriedReport(relatedPersonId, '', repType.Click, pageInfo);
};
// 搜索落地页结果辅助信息区
export const auxiliaryInfo = (pageInfo?: PageInfo) => {
    return buriedReport(auxiliaryInfoId, '', repType.Click, pageInfo);
};

// 在搜索落地页使用右上角头像下拉菜单（临时数据）
export const logClickSearchPageAvatarMenu = (source: string) => {
    return logger(clickSearchPageAvatarMenu, repType.Click, {source});
};

// 我管理的部门页面载入
export const departmentManageLoadLog = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentManageLoadId, '', repType.Show, pageInfo);
};

// 我管理的部门列表点击部门
export const departmentManageListClickLog = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentManageListClickId, '', repType.Click, pageInfo);
};

// 我管理的部门列表点击文档数排序
export const departmentManageDocSortLog = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentManageDocSortId, '', repType.Click, pageInfo);
};

// 我管理的部门列表点击知识库数排序
export const departmentManageRepoSortLog = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentManageRepoSortId, '', repType.Click, pageInfo);
};

// 我管理的部门列表点击成员数排序
export const departmentManageMemberSortLog = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentManageMemberSortId, '', repType.Click, pageInfo);
};

// 我管理的部门列表搜索
export const departmentManageSearchLog = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentManageSearchId, '', repType.Click, pageInfo);
};

// 我管理的部门列表下载
export const departmentManageDownloadLog = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentManageDownloadId, '', repType.Click, pageInfo);
};

// 知识库移动到部门
export const repoMoveInDepartment = (pageInfo?: PageInfo | null) => {
    return buriedReport(repoMoveInDepartmentId, '', repType.Click, pageInfo);
};

// 知识库文档移动
export const docMove = (pageInfo?: PageInfo | null) => {
    return buriedReport(docMoveId, '', repType.Click, pageInfo);
};
// 完成知识库文档移动到功能
export const docMoveToRep = (pageInfo?: PageInfo | null) => {
    return buriedReport(docMoveToRepId, '', repType.Click, pageInfo);
};
// 关于我的汇总信息气泡展示次数
export const aboutMeTooltipShow = (pageInfo?: PageInfo | null) => {
    return buriedReport(aboutMeTooltipId, '', repType.Show, pageInfo);
};
// 阅读态超级助理icon点击次数
export const aiIconClick = (pageInfo?: PageInfo | null) => {
    return buriedReport(aiIconClickId, '', repType.Click, pageInfo);
};
// 「与你相关」模块展示次数
export const aboutMePageShow = (pageInfo?: PageInfo | null) => {
    return buriedReport(aboutMePageShowId, '', repType.Click, pageInfo);
};
// 「与你相关」tab点击次数
export const aboutMeFilterClick = (pageInfo?: PageInfo | null) => {
    return buriedReport(aboutMeFilterClickId, '', repType.Click, pageInfo);
};
// 「与你相关」消息点击次数
export const aboutMeListClick = (pageInfo?: PageInfo | null) => {
    return buriedReport(aboutMeListClickId, '', repType.Click, pageInfo);
};
// 「与你相关」展开
export const aboutMeExpanded = (pageInfo?: PageInfo | null) => {
    return buriedReport(aboutMeExpandedId, '', repType.Click, pageInfo);
};
// 「与你相关」收起
export const aboutMeFewer = (pageInfo?: PageInfo | null) => {
    return buriedReport(aboutMeFewerId, '', repType.Click, pageInfo);
};
// 星联详情点击
export const starlinkDeatilClick = (pageInfo?: PageInfo | null) => {
    return buriedReport(starlinkDeatilClickId, '', repType.Click, pageInfo);
};
// 完成知识库文档复制到功能
export const docCopyToRep = (pageInfo?: PageInfo | null) => {
    return buriedReport(docCopyToRepId, '', repType.Click, pageInfo);
};
// 知识库文档移动到
export const moveToBtn = buriedReport(moveToBtnId, '', repType.Click);
// 知识库文档复制到
export const copyToBtn = buriedReport(copyToBtnId, '', repType.Click);

// 部门公告发布成功上报
export const departmentNoticePublished = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentNoticePublishedId, '', repType.Click, pageInfo);
};

// 部门公告详情打开上报
export const departmentNoticeDetailOpened = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentNoticeDetailId, '', repType.Show, pageInfo);
};

// 部门公告详情打开上报
export const departmentNoticeMsgSend = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentNoticeMsgSendId, '', repType.Click, pageInfo);
};

// 部门公告详情打开上报
export const departmentNoticeOtherSetting = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentNoticeOtherSettingId, '', repType.Click, pageInfo);
};

// 发布公告绑定如流群
export const publishDeptBindGroup = (pageInfo?: PageInfo | null) => {
    return buriedReport(publishDeptBindGroupId, '', repType.Click, pageInfo);
};

// 发布公告解绑如流群
export const publishDeptUnbindGroup = (pageInfo?: PageInfo | null) => {
    return buriedReport(publishDeptUnbindGroupId, '', repType.Click, pageInfo);
};

// 点击部门知识库首页全员公告模块中的全部公告
export const departmentAllAnnouncement = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentAllAnnouncementID, '', repType.Click, pageInfo);
};

// 点击部门知识库首页公告模块
export const departmentAnnouncementModule = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentAnnouncementModuleID, '', repType.Click, pageInfo);
};

// 原热门知识库的点击埋点现在替换到了推荐知识库相关的点击
export const departmentRecommendRepo = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentRecommendRepoID, '', repType.Click, pageInfo);
};

// 点击部门知识库部门外收藏模块
export const departmentCollectionModule = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentCollectionModuleID, '', repType.Click, pageInfo);
};

// 点击部门知识库首页添加部门外收藏
export const departmentAddCollection = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentAddCollectionID, '', repType.Click, pageInfo);
};

// 点击部门首页点击荣誉墙头像埋点
export const departmentWallAvatarClick = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentWallAvatarClickID, '', repType.Click, pageInfo);
};

// 点击部门首页点击荣誉墙知识币文档列表中的文档跳转
export const departmentWallCoinDocClick = (pageInfo?: PageInfo | null) => {
    return buriedReport(departmentWallCoinDocClickID, '', repType.Click, pageInfo);
};

// 统计底部评论回复内容中 @ 人的数量
export const calcBottomCommentMentionNum = (pageInfo?: PageInfo | null) => {
    return buriedReport(bottomCommentMentionNum, '', repType.Click, pageInfo);
};

const editDocFirstID = '80001.2.102';

export const editDocFirstLog = (pageInfo?: PageInfo | null) => {
    return buriedReport(editDocFirstID, '', repType.Click, pageInfo);
};

// 权限优化-部门内公开（知识库、知识本、文档）
export const permissionsOpenDept = (pageInfo?: PageInfo | null) => {
    return buriedReport(permissionsOpenDeptID, '', repType.Click, pageInfo);
};

export const messageCenter = buriedReport(messageCenterId, '', repType.Click);

export const homePageEntry = buriedReport(homePageEntryId, '', repType.Click);

// head DropMenu添加/取消【我关注的】
export const addOrCancelAttention = (pageInfo?: PageInfo | null) => {
    return buriedReport(addOrCancelAttentionFromHeadMenuId, '', repType.Click, pageInfo);
};

// pdf转word 点击转换
export const PDFClickConvertWord = (pageInfo?: PageInfo | null) => {
    return buriedReport(pdf2Word, '', repType.Click, pageInfo);
};

// 下载全部附件点击
export const downloadAttachments = () => {
    return buriedReport(downloadAnnex, '', repType.Click);
};

// pdf转word 点击转换
export const attachmentInformation = (pageInfo?: PageInfo | null) => {
    return buriedReport(attachmentNumSize, '', repType.Click, pageInfo);
};
// 下载原神文件
export const downloadOriginalFileReport = (pageInfo?: PageInfo | null) => {
    return buriedReport(downloadOriginalFileRepId, '', repType.Click, pageInfo);
};

// 打开设置公开时效性
export const openPublicTimeLinessReport = () => {
    return buriedReport(openPublicTimeLiness, '', repType.Click);
};

// 打开团队知识库主页（判断下方列表是使用数据表能力展示 OR 旧的列表形式）
export const openTeamRepoHome = (pageInfo?: PageInfo | null) => {
    return buriedReport(openTeamRepoHomeRepId, '', repType.Show, pageInfo);
};

// 知识库页面权限导出(点击知识库成员管理页中的【导出知识库及页面的权限】按钮)
export const exportRepositoryAuthorityPages = (pageInfo?: PageInfo | null) => {
    return buriedReport(exportRepositoryAuthorityPagesRepId, '', repType.Click, pageInfo);
};
// 创建数据表块埋点
export const createDataSheetBlockReport = (pageInfo?: PageInfo | null) => {
    return buriedReport(CreateDataSheetBlock, '', repType.Click, pageInfo);
};


// 知识库首页点击【上级组织】
export const homeClickOrganization = () => {
    return buriedReport(HomeClickOrganization, '', repType.Click);
};
// 展现「D+组织知识库」首页
export const showGUGroupHome = () => {
    return buriedReport(ShowGUGroupHome, '', repType.Show);
};
// 展现D+的「知识库」 tab
export const showGUGroupRepo = () => {
    return buriedReport(ShowGUGroupRepo, '', repType.Show);
};
// 展现D+的「成员」 tab
export const showGUGroupMember = () => {
    return buriedReport(ShowGUGroupMember, '', repType.Show);
};
// 展现D+的「统计」 tab
export const showGUGroupStatistics = () => {
    return buriedReport(ShowGUGroupStatistics, '', repType.Show);
};

// 展示权限申请页
export const showPermissionPage = () => {
    return buriedReport(PermissionPage, '', repType.Show);
};

// ai模板展示
export const showAiTemplates = (pageInfo?: PageInfo | null) => {
    return buriedReport(showAiTemplatesId, '', repType.Show, pageInfo);
};

// ai模板使用
export const genAiTemplates = (pageInfo?: PageInfo | null) => {
    return buriedReport(genAiTemplatesId, '', repType.Show, pageInfo);
};

// ai模板激活
export const focusAiTemplates = (pageInfo?: PageInfo | null) => {
    return buriedReport(focusAiTemplatesId, '', repType.Show, pageInfo);
};

// 添加知识库问答机器人（确认添加的二级弹窗点击“确定”）的pv、uv
export const addQuestionAnswerConfirm = () => {
    return buriedReport(addQuestionAnswer, '', repType.Click);
};

// 点击“关闭回答功能”的pv、uv
export const closeQuestionAnswerButton = () => {
    return buriedReport(closeQuestionAnswer, '', repType.Click);
};

// 点击“智能问答”的pv、uv
export const clickQuestionAnswerInHelper = () => {
    return buriedReport(clickQuestionAnswerInHelperId, '', repType.Click);
};

// 发送请求的pv、uv
export const sendQuestionAnswer = () => {
    return buriedReport(sendQuestionAnswerId, '', repType.Click);
};


// 日志页面匹配：筛选的用户匹配日志pv、uv
export const searchSettingLogByUser = () => {
    return buriedReport(searchSettingLogByUserBuried, '', repType.Click);
};

// 卡片视图切换
export const switchViewBtnClick = (pageInfo?: PageInfo | null) => {
    return buriedReport(switchViewRepId, '', repType.Click, {
        ...pageInfo,
        source: isInKuShare() ? 'kuShare' : 'ku',
    });
};

// 演示模式下状态切换（文档&&卡片）
export const switchDemoModeStateBtnClick = (pageInfo?: PageInfo | null) => {
    return buriedReport(switchDemoModeStateRepId, '', repType.Click, pageInfo);
};

// 打开文档，若为卡片视图上报
export const recordDocCardView = (pageInfo?: PageInfo | null) => {
    return buriedReport(recordDocCardViewRepId, '', repType.Show, {
        ...pageInfo,
        source: isInKuShare() ? 'kuShare' : 'ku',
    });
};

// 新建场景，卡片视图切换
// 规则：新建场景下（目录树、顶部、其他渠道），切换卡片视图的时候，文档内容 50 个字以内上报
export const newSceneSwitchViewBtnClick = (pageInfo?: PageInfo | null) => {
    return buriedReport(newSceneSwitchViewRepId, '', repType.Click, {
        ...pageInfo,
        source: isInKuShare() ? 'kuShare' : 'ku',
    });
};

// 进入演示模式，默认展示视图
export const enterDemoModeView = (pageInfo?: PageInfo | null) => {
    return buriedReport(enterDemoModeViewRepId, '', repType.Show, pageInfo);
};

// 新建文档默认视图上报
export const createNewDocView = (pageInfo?: PageInfo | null) => {
    return buriedReport(createNewDocViewRepId, '', repType.Show, pageInfo);
};

// 卡片视图——ai模板展示
export const showAiTemplatesInCard = (pageInfo?: PageInfo | null) => {
    return buriedReport(showAiTemplatesInCardId, '', repType.Show, pageInfo);
};

// 卡片视图——ai模板使用
export const genAiTemplatesInCard = (pageInfo?: PageInfo | null) => {
    return buriedReport(genAiTemplatesInCardId, '', repType.Show, pageInfo);
};

// 卡片视图——ai模板激活
export const focusAiTemplatesInCard = (pageInfo?: PageInfo | null) => {
    return buriedReport(focusAiTemplatesInCardId, '', repType.Show, pageInfo);
};

// 页面申请权限增加埋点
export const pageSendApply = (pageInfo?: PageInfo | null) => {
    return buriedReport(pageSendApplyId, '', repType.Click, pageInfo);
};

// 权限审批及审批流程数据建设
export const permissionApply = (params?: any) => {
    return buriedReport(permissionApplyId, '', repType.Click, {
        ...params,
        source: getUrlSource(),
    });
};
// 知识库申请权限增加埋点
export const knowledgeSendApply = (pageInfo?: PageInfo | null) => {
    return buriedReport(knowledgeSendApplyId, '', repType.Click, pageInfo);
};

// 站内通知-页面权限申请点击同意
export const pageAgreeApply = (pageInfo?: PageInfo | null) => {
    return buriedReport(pageAgreeApplyId, '', repType.Click, pageInfo);
};

// 站内通知-页面权限申请点击拒绝
export const pageNotAgreeApply = (pageInfo?: PageInfo | null) => {
    return buriedReport(pageNotAgreeApplyId, '', repType.Click, pageInfo);
};

// 站内通知-知识库权限申请点击同意
export const repoAgreeApply = (pageInfo?: PageInfo | null) => {
    return buriedReport(repoAgreeApplyId, '', repType.Click, pageInfo);
};

// 站内通知-知识库权限申请点击拒绝
export const repoNotAgreeApply = (pageInfo?: PageInfo | null) => {
    return buriedReport(repoNotAgreeApplyId, '', repType.Click, pageInfo);
};

// 知识库设置审批权限埋点
export const repoSettingApply = (pageInfo?: PageInfo | null) => {
    return buriedReport(repoSettingApplyId, '', repType.Click, pageInfo);
};

// 展示指定渠道强化投币气泡
export const reportShowStrengthenCoinGuidance = () => {
    return buriedReport(showStrengthenCoinGuidance, '', repType.Show);
};
// 点击指定渠道强化投币气泡关闭
export const reportCloseStrengthenCoinGuidance = () => {
    return buriedReport(closeStrengthenCoinGuidance, '', repType.Click);
};
// 通过指定渠道强化投币气泡投币
export const reportDepositStrengthenCoinGuidance = () => {
    return buriedReport(depositStrengthenCoinGuidance, '', repType.Click);
};

// 文档一键回顶
export const returnTopBtn = (pageInfo?: PageInfo | null) => {
    return buriedReport(returnTopId, '', repType.Click, pageInfo);
};
// 点击洞听埋点
export const dongtingBtn = (pageInfo?: PageInfo | null) => {
    return buriedReport(dongtingId, '', repType.Click, pageInfo);
};
export const reportGiveCoinShowShareDocBtn = () => {
    return buriedReport(giveCoinShowShareDocBtn, '', repType.Show);
};
export const reportGiveCoinClickShareDocBtn = () => {
    return buriedReport(giveCoinClickShareDocBtn, '', repType.Click);
};
export const reportGiveCoinShowShareDocDialog = () => {
    return buriedReport(giveCoinShowShareDocDialog, '', repType.Show);
};
export const reportGiveCoinConfirmShareDoc = (number: number) => {
    return buriedReport(giveCoinConfirmShareDoc, '', repType.Click, {number});
};

export const clickShowCover = (pageInfo?: PageInfo | null) => {
    return buriedReport(showCoverRepId, '', repType.Click, pageInfo);
};

// 文档投诉入口按钮
export const reportDocComplainBtn = (pageInfo?: PageInfo | null) => {
    return buriedReport(docComplainBtnRepId, '', repType.Click, pageInfo);
};

// 文档投诉
export const reportDocComplain = (pageInfo?: PageInfo | null) => {
    return buriedReport(docComplainRepId, '', repType.Click, pageInfo);
};

// 团队知识库首页数据表Tab点击
export const reportRepoHomeDatasheetTabClick = (pageInfo?: PageInfo | null) => {
    return buriedReport(repoHomeDatasheetTabReqId, '', repType.Click, pageInfo);
};

export const reportDatasheetCreateView = (pageInfo?: PageInfo | null) => {
    return buriedReport(datasheetCreateViewRepId, '', repType.Click, pageInfo);
};

export const reportDatasheetSumTableCreate = (pageInfo?: PageInfo | null) => {
    return buriedReport(datasheetSumTableCreateId, '', repType.Click, pageInfo);
};

export const reportDatasheetSumTableUpdate = (pageInfo?: PageInfo | null) => {
    return buriedReport(datasheetSumTableUpdateId, '', repType.Click, pageInfo);
};

// 知识库文档移动优化
export const clickDocMove = (options: any) => {
    return feLogger({
        rep_id: clickDocMoveId,
        rep_type: 'click',
        rep_params: {
            ...options,
        },
    });
};

export const reportBodyOverFlow = (pageInfo?: PageInfo | null) => {
    return buriedReport(bodyOverFlowRepId, '', repType.Click, pageInfo);
};

export const clickPageMoveRep = (data: any) => {
    feLogger({
        rep_id: pageMoveRepId,
        rep_type: repType.Click,
        rep_params: {...data},
    });
};

// 点击知识库设置
export const clickRepoSettings = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickRepoSettingsId, '', repType.Click, pageInfo);
};
// 用户点击设置页下二级tab
export const clickRepoSettingsTab = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickRepoSettingsTabId, '', repType.Click, pageInfo);
};

export const clickInviteReaderSetting = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickInviteReaderSettingId, '', repType.Click, pageInfo);
};
export const clickInviteEditorSetting = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickInviteEditorSettingId, '', repType.Click, pageInfo);
};
// 用户点击跳转对应文档
export const clickSettingDoc = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickSettingDocId, '', repType.Click, pageInfo);
};
// 协作设置确认关闭弹窗曝光
export const showInviteSettingDialog = (pageInfo?: PageInfo | null) => {
    return buriedReport(showInviteSettingDialogId, '', repType.Show, pageInfo);
};
// 用户点击维持现状
export const clickInviteSettingDialogCancel = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickInviteSettingDialogCancelId, '', repType.Click, pageInfo);
};
// 用户点击坚持关闭
export const clickInviteSettingDialogConfirm = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickInviteSettingDialogConfirmId, '', repType.Click, pageInfo);
};

// 复制设置确认关闭弹窗曝光
export const showCopySettingDialog = (pageInfo?: PageInfo | null) => {
    return buriedReport(showCopySettingDialogId, '', repType.Show, pageInfo);
};
// 复制设置用户点击维持现状
export const clickCopySettingDialogCancel = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickCopySettingDialogCancelId, '', repType.Click, pageInfo);
};
// 复制设置用户点击坚持关闭
export const clickCopySettingDialogConfirm = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickCopySettingDialogConfirmId, '', repType.Click, pageInfo);
};
// 无主知识库页面曝光
export const reportShowNoOwnerRepo = () => {
    return buriedReport(showNoOwnerRepoId, '', repType.Show, {
        source: getUrlSource(),
    });
};

// 无主知识库 点击百度流程中心
export const reportClickFlowCenter = () => {
    return buriedReport(clickFlowCenterId, '', repType.Click, {
        source: getUrlSource(),
    });
};

// 用户点击「分享」按钮的次数
export const clickHeadShareBtn = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickHeadShareBtnId, '', repType.Click, pageInfo);
};

// 用户点击打开/关闭文档公开设置
export const clickPublicDocBtn = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickPublicDocBtnId, '', repType.Click, pageInfo);
};
// 用户点击打开/关闭文档分享阅读设置
export const clickQuickShareBtn = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickQuickShareBtnId, '', repType.Click, pageInfo);
};
// 用户点击打开/关闭文档协同编辑设置
export const clickQuickEditorBtn = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickQuickEditorBtnId, '', repType.Click, pageInfo);
};
// 用户点击更多权限设置
export const clickPowerSettingBtn = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickPowerSettingBtnId, '', repType.Click, pageInfo);
};
// 用户点击权限申请
export const clickPowerApplyBtn = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickPowerApplyBtnId, '', repType.Click, pageInfo);
};
// 确认关闭弹窗曝光pv、uv
export const showCloseDialog = (pageInfo?: PageInfo | null) => {
    return buriedReport(showCloseDialogId, '', repType.Show, pageInfo);
};
// 用户点击维持现状
export const clickPowerDialogCancelBtn = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickPowerDialogCancelBtnId, '', repType.Click, pageInfo);
};
// 用户点击坚持关闭
export const clickPowerDialogConfirmBtn = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickPowerDialogConfirmBtnId, '', repType.Click, pageInfo);
};

// 确认关闭弹窗曝光pv、uv
export const showCloseCopyDialog = (pageInfo?: PageInfo | null) => {
    return buriedReport(showCloseCopyDialogId, '', repType.Show, pageInfo);
};

// 用户点击维持现状
export const clickCopyDialogCancelBtn = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickCopyDialogCancelBtnId, '', repType.Click, pageInfo);
};
// 用户点击坚持关闭
export const clickCopyDialogConfirmBtn = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickCopyDialogConfirmBtnId, '', repType.Click, pageInfo);
};

// 点击在线表格历史版本
export const reportClickSheetHistory = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickSheetHistoryRepId, '', repType.Click, pageInfo);
};

// 常协同组织推荐模块展示次数
export const showDocRecommendGroupCount = (pageInfo?: PageInfo | null) => {
    return buriedReport(showDocRecommendGroupCountId, '', repType.Show, pageInfo);
};
// 常协同组织推荐-授权次数
export const clickDocRecommendGroupCount = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickDocRecommendGroupCountId, '', repType.Click, pageInfo);
};
// 常协同组织推荐-查看群聊成员次数
export const showDocRecommendGroupMember = (pageInfo?: PageInfo | null) => {
    return buriedReport(showDocRecommendGroupMemberId, '', repType.Show, pageInfo);
};
// 成员列表页&添加成员页-添加部门权限
export const clickDocPageUpdateDepartMember = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickDocPageUpdateDepartMemberId, '', repType.Click, pageInfo);
};
// 检测到相关群聊展示次数
export const showAddMemberPageRecommendGroup = (pageInfo?: PageInfo | null) => {
    return buriedReport(showAddMemberPageRecommendGroupId, '', repType.Show, pageInfo);
};
// 点击【添加群聊权限】次数
export const clickAddMemberPageRecommendGroup = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickAddMemberPageRecommendGroupId, '', repType.Click, pageInfo);
};
// 知识库常协同组织推荐模块-展示次数
export const showRepoRecommendGroupCount = (pageInfo?: PageInfo | null) => {
    return buriedReport(showRepoRecommendGroupCountId, '', repType.Show, pageInfo);
};
// 知识库常协同组织推荐模块-授权次数
export const clickRepoRecommendGroupCount = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickRepoRecommendGroupCountId, '', repType.Click, pageInfo);
};

// 点击一键插入子文档列表卡
export const reportClickInsertSubDocList = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickInsertSubDocList, '', repType.Click, pageInfo);
};

// 一键拆卡tip展示
export const showSplitCardRecommendTip = (pageInfo?: PageInfo | null) => {
    return buriedReport(splitCardRecommendShow, '', repType.Show, pageInfo);
};

// 一键拆卡tip关闭
export const closeSplitCardRecommendTip = (pageInfo?: PageInfo | null) => {
    return buriedReport(splitCardRecommendClose, '', repType.Click, pageInfo);
};

// 展现量：插入子文档列表卡引导
export const reportShowInsertSubDocList = (pageInfo?: PageInfo | null) => {
    return buriedReport(showInsertSubDocList, '', repType.Show, pageInfo);
};
// 内链授权推荐展示
export const showShareDialogRecommendPower = (pageInfo?: PageInfo | null) => {
    return buriedReport(showShareDialogRecommendPowerId, '', repType.Show, pageInfo);
};
// 内链授权推荐点击
export const clickShareDialogRecommendPower = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickShareDialogRecommendPowerId, '', repType.Click, pageInfo);
};
// 更多内页面权限工具点击
export const clickMorePowerList = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickMorePowerListId, '', repType.Click, pageInfo);
};
// 内链批量授权 - 实际授权
export const clickPowerModalConfirm = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickPowerModalConfirmId, '', repType.Click, pageInfo);
};
export const reportTokenRetryError = (pageInfo?: PageInfo | null) => {
    return buriedReport(tokenRetryErrorRepId, '', repType.Click, pageInfo);
};

export const reportTokenRetryByGetKsServer = (pageInfo?: PageInfo | null) => {
    return buriedReport(tokenRetryByGetKsServerRepId, '', repType.Click, pageInfo);
};

// 关闭评论侧边栏时评论未提交
export const reportCloseCommentSidebar = (options: PageInfo | null) => {
    return feLogger({
        rep_id: closeCommentSidebarId,
        rep_type: 'click',
        rep_params: {
            ...options,
        },
    });
};

export const clickOpenMoveTo = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickOpenMoveToId, '', repType.Click, pageInfo);
};

// 点击新建知识库
export const clickAddRepo = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickAddRepoId, '', repType.Click, pageInfo);
};

// 新建知识库成功
export const addRepoSuccess = (pageInfo?: PageInfo | null) => {
    return buriedReport(addRepoSuccessId, '', repType.Click, pageInfo);
};

// 新建知识本埋点
const newKnowledgeBookId = '80001.1.336';
export const clickNewKnowledgeBook = (pageInfo?: PageInfo | null) => {
    return buriedReport(newKnowledgeBookId, '', repType.Click, pageInfo);
};

export const clickSwitchNewKnowledgeBook = (pageInfo?: PageInfo | null) => {
    return buriedReport(switchKnowledgeBookTypeId, '', repType.Click, pageInfo);
};

// 进入多选模式
export const clickEnterSelectBatch = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickEnterSelectBatchId, '', repType.Click, pageInfo);
};

// 多选模式下选择文档
export const clickSelectBatchDoc = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickSelectBatchDocId, '', repType.Click, pageInfo);
};

// 多选模式下选择文档
export const clickEnterPowerModal = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickEnterPowerModalId, '', repType.Click, pageInfo);
};

// 完成实际授权
export const clickAddAllPower = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickAddAllPowerId, '', repType.Click, pageInfo);
};

// 点击批量复制
export const clickBatchCopyBtn = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickBatchCopyBtnId, '', repType.Click, pageInfo);
};
// 批量复制浮窗展示
export const showBatchDialog = (pageInfo?: PageInfo | null) => {
    return buriedReport(showBatchDialogId, '', repType.Click, pageInfo);
};
// 无权提醒
export const clickBatchNoPower = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickBatchNoPowerId, '', repType.Click, pageInfo);
};
// 确认复制
export const clickBatchCopy = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickBatchCopyId, '', repType.Click, pageInfo);
};
// 快速移动到顶部
export const clickMoveToTop = (pageInfo?: PageInfo | null) => {
    return buriedReport(moveToTopId, '', repType.Click, pageInfo);
};

// 快速移动到底部
export const clickMoveToBottom = (pageInfo?: PageInfo | null) => {
    return buriedReport(moveToBottomId, '', repType.Click, pageInfo);
};

// 点击批量移动
export const clickBatchMoveEntry = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickBatchMoveEntryId, '', repType.Click, pageInfo);
};
// 批量移动浮窗展示
export const showBatchMoveDialog = (pageInfo?: PageInfo | null) => {
    return buriedReport(showBatchMoveDialogId, '', repType.Click, pageInfo);
};
// 无权提醒
export const clickNoPower = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickNoPowerId, '', repType.Click, pageInfo);
};
// 确认移动
export const clickBatchMoveBtn = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickBatchMoveBtnId, '', repType.Click, pageInfo);
};

// 内部用户文档访问量
export const clickExternalDocType = (pageInfo?: PageInfo | null) => {
    if (getIsTestRepo()) {
        return;
    }
    return buriedReport(clickExternalUserDocTypeId, '', repType.Click, pageInfo);
};
// 外部用户文档访问量
export const clickUserDocType = (pageInfo?: PageInfo | null) => {
    if (getIsTestRepo()) {
        return;
    }
    return buriedReport(clickUserDocTypeId, '', repType.Click, pageInfo);
};
// 内部用户文档编辑量
export const clickExternalUserEditor = (pageInfo?: PageInfo | null) => {
    if (getIsTestRepo()) {
        return;
    }
    return buriedReport(clickExternalUserEditorId, '', repType.Click, pageInfo);
};
// 外部用户文档编辑量
export const clickUserEditor = (pageInfo?: PageInfo | null) => {
    if (getIsTestRepo()) {
        return;
    }
    return buriedReport(clickUserEditorId, '', repType.Click, pageInfo);
};
// 点击右下角帮助中心
export const reportClickHelpCenterItem = (pageInfo?: PageInfo | null) => {
    return buriedReport(clickHelpCenterItemId, '', repType.Click, pageInfo);
};
